<style>
#map {
  min-width: 100%;
}
.ol-zoom {
  top: 45px !important;
}
.wrapper__viewer .mapContainer {
  height: calc(100vh - 26px);
}
.wrapper__viewer.expand .mapContainer {
  height: calc(100vh - 109px) !important;
}

.ol-zoom-in,
.ol-zoom-out {
  background-color: #304058 !important;
}
.ol-scale-line {
  background-color: #304058 !important;
  opacity: 0.6;
}
.ol-mouse-position {
  top: inherit !important;
  bottom: 8px;
  right: 8px;
  background: rgba(48, 64, 88, 0.6);
  color: white;
  text-align: right;
  padding: 2px;
  font-size: 10px;
  border-radius: 4px;
}
</style>

<template>
  <div
    id="map"
    class="mapContainer"
    v-pre
  >
  </div>
</template>

<script>
import proj4 from "proj4";
import Map from "ol/Map";
import View from "ol/View";
import Collection from "ol/Collection";
import {
  Group as LayerGroup,
  Vector as VectorLayer,
  Tile as TileLayer
} from "ol/layer";
import VectorTileLayer from "ol/layer/VectorTile";
import VectorTileSource from "ol/source/VectorTile";
import {Vector as VectorSource, WMTS, XYZ, TileWMS, Cluster} from "ol/source";
import MVT from "ol/format/MVT";
import {GeoJSON} from "ol/format";
import WKT from "ol/format/WKT";
import {
  Style,
  Stroke,
  Icon,
  Fill,
  Circle,
  RegularShape,
  Text
} from "ol/style";
import WMTSTileGrid from "ol/tilegrid/WMTS";
import Projection from "ol/proj/Projection.js";
import {register} from "ol/proj/proj4.js";
import {getArea, getLength} from "ol/sphere.js";
import {
  Geometry,
  LineString,
  Polygon,
  MultiPoint,
  MultiPolygon,
  MultiLineString,
  Point
} from "ol/geom";
import LinearRing from "ol/geom/LinearRing";
import GeometryCollection from "ol/geom/GeometryCollection";
import {Draw, Snap, DragBox} from "ol/interaction";
import ScaleLine from "ol/control/ScaleLine";
import Feature from "ol/Feature";
import MousePosition from "ol/control/MousePosition.js";
import {defaults as defaultControls} from "ol/control.js";
import {createStringXY} from "ol/coordinate.js";
import {easeOut} from "ol/easing";
import {unByKey} from "ol/Observable";
import {fromLonLat} from "ol/proj.js";
import {asArray as asArrayColor} from "ol/color.js";
import {defaults as defaultInteractions} from "ol/interaction.js";
import {click, pointerMove} from "ol/events/condition.js";
import Overlay from "ol/Overlay.js";
import {transform} from "ol/proj.js";

import gu from "../../../utils/geometry.js";
import {ProxyObserver} from "../../../utils/ProxyObserver";
import ces from "../../../utils/CustomEditingStyle.js";

import OL3Parser from "jsts/org/locationtech/jts/io/OL3Parser";
import {Coordinate} from "jsts/org/locationtech/jts/geom";

const ol_parser = new OL3Parser();
ol_parser.inject(
  Point,
  LineString,
  LinearRing,
  Polygon,
  MultiPoint,
  MultiLineString,
  MultiPolygon,
  GeometryCollection
);

import niceRange from "../../../utils/niceRange.js";

import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import map from "lodash/map";
import filter from "lodash/filter";
import keyBy from "lodash/keyBy";
import mapValues from "lodash/mapValues";
import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";
import each from "lodash/each";
import get from "lodash/get";
import flatten from "lodash/flatten";
import debounce from "lodash/debounce";
import join from "lodash/join";
import findIndex from "lodash/findIndex";
import defaults from "lodash/defaults";
import some from "lodash/some";
mixin(_, {
  chain,
  map,
  filter,
  keyBy,
  mapValues,
  includes,
  get: get,
  isEmpty,
  each,
  flatten,
  debounce,
  join,
  findIndex,
  defaults,
  some
});
_.value = value;
_.prototype.value = value;


const minSizePoint = 1.0;
const maxSizePoint = 10.0;
const widthSizePoint = maxSizePoint - minSizePoint;
function generateDefModelWod(type, attribute, ranges, legend) {
  const def = {
    range: [],
    min: 0,
    max: 0,
    width: 0
  };
  if(attribute !== "null") {
    if(attribute in legend[type]) {
      def.range = legend[type][attribute];

      def.min = def.range[0];
      def.max = def.range[3];
    } else if('range' in ranges[type][attribute]) {
      def.range = ranges[type][attribute].range;

      def.min = def.range[0];
      def.max = def.range[3];
    } else {
      def.min = ranges[type][attribute].min;
      def.max = ranges[type][attribute].max;

      def.range = [def.min, ...niceRange([def.min, def.max], 1), def.max];
    }

    def.width = def.max - def.min;
  }
  return def;
}
const category5Color = [
  '#2001ff',
  '#7dfbfb',
  '#79fb17',
  '#fcfe00',
  '#e52e2d'
];
const category5Size = [
  1,
  2.5,
  4,
  5.5,
  7
];
function findColor(range, value) {
  let idx = _.findIndex(range, v => v >= value);
  if(idx === -1) {
    idx = category5Color.length - 1;
  }
  return category5Color[idx];
}
function findSize(range, value) {
  let idx = _.findIndex(range, v => v >= value);
  if(idx === -1) {
    idx = category5Size.length - 1;
  }
  return category5Size[idx];
}

const valvesStateIcons = {
  "NULL": require(`../../../assets/map_icons/valves_else.svg`),
  "Inny": require(`../../../assets/map_icons/valves_else.svg`),
  "Brak danych": require(`../../../assets/map_icons/valves_else.svg`),
  "Otwarty": require(`../../../assets/map_icons/valves_open_work.svg`),
  "Zamknięty": require(`../../../assets/map_icons/valves_close_work.svg`),
  "Uszkodzony otwarty": require(`../../../assets/map_icons/valves_open_not_work.svg`),
  "Uszkodzony zamknięty": require(`../../../assets/map_icons/valves_close_not_work.svg`),
};

export default {
  data: () => ({
    currentVisibleTask: undefined,
    isFirstAnimation: false,
    valvesInterval: undefined,
    partitionsInterval: undefined,
    visibleLayersCounter: 0,
    tmpCounter: 0,
    numericScale: 1,

    area: "0 m<sup>2</sup>",
    length: "0 m",
    measuring: false,
    mapColors: {
      'Przyjęto wniosek': {
        'fill': 'rgba(255, 213, 0, 0.5)',
        'stroke': 'rgba(189, 158, 0, 1)',
      },
      'Wydano warunki': {
        'fill': 'rgba(66, 135, 245, 0.5)',
        'stroke': 'rgba(7, 57, 138, 1)',
      },
      'Odpowiedź odmowna': {
        'fill': 'rgba(235, 64, 52, 0.5)',
        'stroke': 'rgba(145, 19, 10, 1)',
      },
      'Przyjęto projekt': {
        'fill': 'rgba(63, 163, 0, 0.5)',
        'stroke': 'rgba(35, 82, 5, 1)',
      },
      'W trakcie inwestycji': {
        'fill': 'rgba(168, 0, 160, 0.5)',
        'stroke': 'rgba(97, 4, 92, 1)',
      },
      'Inwestycja odebrana': {
        'fill': 'rgba(168, 101, 0, 0.5)',
        'stroke': 'rgba(115, 72, 7, 1)',
      },
      'Inwestycja nieodebrana': {
        'fill': 'rgba(110, 89, 57, 0.5)',
        'stroke': 'rgba(56, 44, 26, 1)',
      },
      'Inne': {
        'fill': 'rgba(57, 26, 110, 0.5)',
        'stroke': 'rgba(28, 10, 59, 1)',
      },
      'Nowe': {
        'fill': 'rgba(235, 64, 52, 0.5)',
        'stroke': 'rgba(235, 64, 52, 1)',
      },
      'Zaplanowane': {
        'fill': 'rgba(255, 213, 0, 0.5)',
        'stroke': 'rgba(255, 213, 0, 1)',
      },
      'Zlecone wykonanie': {
        'fill': 'rgba(168, 0, 160, 0.5)',
        'stroke': 'rgba(168, 0, 160, 1)',
      },
      'W trakcie': {
        'fill': 'rgba(66, 135, 245, 0.5)',
        'stroke': 'rgba(66, 135, 245, 1)',
      },
      'Zakończone': {
        'fill': 'rgba(63, 163, 0, 0.5)',
        'stroke': 'rgba(63, 163, 0, 1)',
      },
      'ustanowiona': {
        'fill': 'rgba(255, 213, 0, 0.5)',
        'stroke': 'rgba(189, 158, 0, 1)',
      },
      'w trakcie ustanawiania': {
        'fill': 'rgba(66, 135, 245, 0.5)',
        'stroke': 'rgba(7, 57, 138, 1)',
      },
      'nieustanowiona': {
        'fill': 'rgba(235, 64, 52, 0.5)',
        'stroke': 'rgba(145, 19, 10, 1)',
      },
      'Osoba fizyczna': {
        'fill': 'rgba(255, 213, 0, 0.5)',
        'stroke': 'rgba(189, 158, 0, 1)',
      },
      'Skarb Państwa': {
        'fill': 'rgba(66, 135, 245, 0.5)',
        'stroke': 'rgba(7, 57, 138, 1)',
      },
      'Województwo': {
        'fill': 'rgba(235, 64, 52, 0.5)',
        'stroke': 'rgba(145, 19, 10, 1)',
      },
      'Powiat': {
        'fill': 'rgba(63, 163, 0, 0.5)',
        'stroke': 'rgba(35, 82, 5, 1)',
      },
      'Gmina': {
        'fill': 'rgba(168, 0, 160, 0.5)',
        'stroke': 'rgba(97, 4, 92, 1)',
      },
      'Osoba prawna': {
        'fill': 'rgba(168, 101, 0, 0.5)',
        'stroke': 'rgba(115, 72, 7, 1)',
      },
      'Spółdzielnie': {
        'fill': 'rgba(110, 89, 57, 0.5)',
        'stroke': 'rgba(56, 44, 26, 1)',
      },
      'Brak danych': {
        'fill': 'rgba(181, 169, 138, 0.5)',
        'stroke': 'rgba(117, 110, 91, 1)',
      },
    },
    identification: false,
    selectFeatures: false
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    basemapOpacity() {
      return this.$store.getters.getBasemapOpacity;
    },
    currentBookmark() {
      return this.$store.getters.getCurrentBookmark;
    },
    currentEditedLayer() {
      return this.$store.getters.getCurrentEditedLayer;
    },
    currentEditedLayerStyle() {
      let currentLayer = this.selectLayerByName(this.currentEditedLayer);
      if(!currentLayer) {
        currentLayer = this.selectLayerByName(this.currentEditedLayer, "user");
      }
      return currentLayer.getStyle();
    },
    currentCoordSystem() {
      return this.$store.getters.getCurrentCoordSystem;
    },
    currentScadaPoint() {
      return this.$store.getters.getCurrentScadaPoint;
    },
    editionOn() {
      return this.$store.getters.getEditionOn;
    },
    currentUser() {
      return this.$store.getters.getUser;
    },
    baseSrid() {
      return this.$store.getters.getSrid;
    },

    selectedLayer() {
      return this.map
        .getLayers()
        .item(3)
        .getLayers()
        .item(0);
    },
    snapTolerance() {
      return this.$store.getters.getSnapTolerance;
    },

    modelWatDisplaySettings() {
      return this.$store.getters.getModelWatDisplaySettings;
    },
    modelWatTimeStep() {
      return this.$store.getters.getModelWatTimeStep;
    },

    layers() {
      return this.$store.getters.getLayers;
    },
    visibleLayers() {
      return this.$store.getters.getVisibleLayers;
    },
    currentBasemap() {
      return this.$store.getters.getCurrentBasemap;
    },
    layersWater() {
      return this.$store.getters.getLayersWater;
    },
    layersSewer() {
      return this.$store.getters.getLayersSewer;
    },
    appLayers() {
      return this.$store.getters.getAppLayers;
    },
    userLayers() {
      return this.$store.getters.getUserLayers;
    },
    sketchesLayers() {
      return this.$store.getters.getSketches;
    },
    baselayers() {
      return this.$store.getters.getBaselayers;
    },
    wmtsTilegrid() {
      return this.$store.getters.getWmtsTilegrid;
    },
    wmtsTilegridGeoportal() {
      return this.$store.getters.getWmtsTilegridGeoportal;
    },
    folderData() {
      return this.$store.getters.getFolderData;
    },
    geoportalName() {
      return this.$store.getters.getAquagisName;
    },

    layersInstance() {
      return this.$store.getters.getLayersInstance;
    },
    getVideoCards() {
      return this.$store.getters.getVideoInspectionCards;
    },

    styles() {
      return this.$store.getters.getStyles;
    },
    showDirectionFlows() {
      return this.$store.getters.getShowDirectionFlows;
    },
    labelsShow() {
      return this.$store.getters.getLabelsShow;
    },
    showValvesState() {
      return this.$store.getters.getShowValvesState;
    },
    users() {
      return this.$store.getters.getUsers;
    }
  },
  watch: {
    measuring(_new) {
      this.measuringTool.setActive(_new);
      if(!_new) {
        this.currentMeasurement = undefined;
        this.area = "0 m";
        this.length = "0 m";
        const source = this.measureLayer.getSource();
        source.clear();
      }
    },
    currentEditedLayer(_new) {
      this._computedWatchers.currentEditedLayerStyle.update();
    },
    snapTolerance(_new) {
      if(this.snapMeasureInteraction) {
        this.map.removeInteraction(this.snapMeasureInteraction);
      }
      this.createSnapMeasure();
    },
    labelsShow() {
      this.refreshStyles();
    },
    modelWatDisplaySettings() {
      this.refreshModelWat();
    },
    modelWatTimeStep() {
      this.refreshModelWat(false);
    },
    showDirectionFlows() {
      this.refreshStyles();
    },
    showValvesState() {
      this.refreshStyles();
    },
  },
  methods: {
    show(title) {
      if(this.activeModals.indexOf(title) === -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    createNumericScale() {
      let units = this.map.getView().getProjection().getUnits();
      let resolution = this.map.getView().getResolution();
      let INCHES_PER_UNIT = {
        'm': 39.37,
        'dd': 4374754
      };
      let DOTS_PER_INCH = 72;
      let scale = INCHES_PER_UNIT[units] * DOTS_PER_INCH * resolution;
      this.$root.$emit('setNumericScale', Math.round(scale));
    },
    clone(data) {
      return JSON.parse(JSON.stringify(data));
    },
    getZoom() {
      return this.map.getView().getZoom();
    },
    getStyles() {
      this.$store.dispatch("getStyles").then(r => {
        if(!r) {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Błąd pobierania styli warstw"
          );
        } else {
          this.getAppLayers();
          this.getAppLayersMeta();
          this.getLayers();
          this.$watch("styles", this.updateStyles);
        }
      });
    },
    getLayers() {
      // Get layers available for current user
      this.$store.dispatch("getLayers").then(r => {
        if(!r) {
          this.$root.$emit("showSnackbar", "red", "Błąd pobierania warstw");
        } else {
          this.loadLayers();
        }
      });
    },
    zoomToFeature(feature, options = {}) {
      if(!(feature instanceof Feature)) {
        feature = new GeoJSON().readFeature(feature, {
          featureProjection: this.$root.projection,
          dataProjection: options.srid || this.$root.projection
        });
      }
      this.zoomToGeometry(feature.getGeometry(), options);
    },
    zoomToGeometry(geometry, options = {}) {
      if(!geometry) return;
      // options.minResolution = 0.1;
      options.maxZoom = options.maxZoom || 20;
      options.duration = options.duration || 2000;
      options.easing = options.easing || easeOut;
      this.map.getView().fit(geometry, options);
      this.flashGeometries(geometry, {zoom : false});

      if (options && options.select) {
        this.selectedLayer.getSource().clear(true);
        this.selectedLayer.getSource().addFeature(new Feature({geometry}));
      }
    },
    zoomToExtent(extent, options = {}) {
      if(!extent) return;
      // options.minResolution = 0.1;
      options.maxZoom = options.maxZoom || 20;
      options.duration = options.duration || 2000;
      options.easing = options.easing || easeOut;
      this.map.getView().fit(extent, options);
    },
    zoomToBBox(bbox, options = {}) {
      if(!bbox) return;
      this.zoomToExtent([bbox[0][0], bbox[0][1], bbox[1][0], bbox[1][1]], options);
    },
    zoomToLayer(layer) {
      this.zoomToExtent(layer.getSource().getExtent(), {
        duration: 1000
      });
    },
    loadLayers() {
      // Creates empty ol/VectorLayer for each layer
      // source is lazily-loaded on layer's first `setVisible(true)`
      this.loadWaterLayers();
      this.loadSewerLayers();

      for(let layer in this.visibleLayers) {
        if(this.visibleLayers[layer] === true) {
          this.toggleLayer(layer);
          this.visibleLayersCounter++;
        }
      }
      this.switchBasemapByName(this.currentBasemap);
    },


    fieldsToMap(fields) {
      return _(fields)
        .filter(field => "dictionary" in field)
        .map(field => ({
          name: field.name,
          dictionary: field.dictionary
        }))
        .keyBy("name")
        .mapValues("dictionary")
        .value();
    },
    loadWaterLayers() {
      for(let l of this.layersWater) {
        let vlayer;
        if(l.type === "watermeters") {
          const source = new VectorSource({
            features: new Collection()
          });
          const zoomOffClustering = 19;
          const clusteringDistance = {
            simple: 50,
            full: 1
          };

          const clusterSource = new Cluster({
            distance: clusteringDistance.simple,
            source,
            geometryFunction(feature) {
              return feature.getGeometry();
            }
          });
          clusterSource.set("id", "source_" + l.full_type);

          const origStyle = this.styles.layers[l.type];
          //delete origStyle.style_id;
          let styleObject = this.createLayerStyle(l.type, origStyle, {
            fields: this.fieldsToMap(l.fields)
          });
          if(!styleObject) {
            console.log(`Błedna stylizacja lub klucz dla '${l.type}'`);
            styleObject = () => ([]);
          }

          vlayer = new VectorLayer({
            source: clusterSource,
            visible: false,
            fields: l.fields,
            style: this.createClusterStyle(styleObject),
            maxResolution: this.map
              .getView()
              .getResolutionForZoom(origStyle ? (origStyle.minzoom || 0) : 0),
          });

          //grupowanie w zależności od zoomu
          this.map.getView().on('change:resolution', ({target}) => {
            const distance = target.getZoom() >= zoomOffClustering ? clusteringDistance.full : clusteringDistance.simple;
            if(clusterSource.getDistance() !== distance) {
              clusterSource.setDistance(distance);
            }
          }, this.map);

          vlayer.getFeatureId = function (feature) {
            const features = feature.get("features");
            return features.length === 1 ? features[0].getId() : this.getId();
          };
          vlayer.getFeatureProperties = function (feature) {
            const features = feature.get("features");
            return features.length === 1 ? features[0].getProperties() : this.getProperties();
          };
        } else if(l.geometry_type === "none") {
          vlayer = new VectorLayer({
            source: new VectorSource(),
            visible: false,
            fields: l.fields
          });
        } else {
          const origStyle = this.styles.layers[l.type];
          //delete origStyle.style_id;
          let styleObject = this.createLayerStyle(l.type, origStyle, {
            fields: this.fieldsToMap(l.fields)
          });
          if(!styleObject) {
            console.log(`Błedna stylizacja lub klucz dla '${l.type}'`);
            styleObject = () => ([]);
          }

          const source = new VectorSource({
            features: new Collection()
          });
          source.set("id", "source_" + l.full_type);

          vlayer = new VectorLayer({
            source,
            style: styleObject,
            maxResolution: this.map
              .getView()
              .getResolutionForZoom(origStyle ? (origStyle.minzoom || 0) : 0),
            visible: false,
            fields: l.fields
          });
        }

        Object.keys(l).forEach(prop => {
          vlayer.set(prop, l[prop]);
        });

        this.addLayer(vlayer);
      }
    },
    loadSewerLayers() {
      for(let l of this.layersSewer) {
        //delete this.styles.layers[l.type].style_id;
        let origStyle = this.styles.layers[l.type][l.net_type];
        let styleObject = this.createLayerStyle(l.type, origStyle, {
          fields: this.fieldsToMap(l.fields)
        });
        if(!styleObject) {
          console.log(`Błedna stylizacja lub klucz dla '${l.net_type}' w '${l.type}'`);
          styleObject = () => ([]);
        }

        const source = new VectorSource({
          features: new Collection()
        });
        source.set("id", "source_" + l.full_type);

        const vlayer = new VectorLayer({
          source,
          style: styleObject,
          maxResolution: this.map
            .getView()
            .getResolutionForZoom(origStyle ? (origStyle.minzoom || 0) : 0),
          visible: false,
          fields: l.fields
        });

        Object.keys(l).forEach(prop => {
          vlayer.set(prop, l[prop]);
        });

        this.addLayer(vlayer);
      }
    },
    selectLayerByName(layername, type, ignore_data = false) {
      //znalezienie wastwy danych
      let layers = [];
      let idx = -1;
      switch(type) {
        case "wms":
          layers = this.map
            .getLayers()
            .item(0)
            .getLayers()
            .getArray();
          break;
        case "additional":
        case "data":
          idx = ["additional", "", "data"].indexOf(type);
          if(idx > -1) {
            layers = this.map
              .getLayers()
              .item(idx)
              .getLayers()
              .getArray();
            break;
          }
          break;
        case "user":
        case "temp":
        case "sketche":
          idx = ["user", "temp", "sketche"].indexOf(type);
          if(idx > -1) {
            layers = this.map
              .getLayers()
              .item(1)
              .getLayers()
              .item(idx)
              .getLayers()
              .getArray();
            break;
          }
        default:
          layers = this.map
            .getLayers()
            .item(2)
            .getLayers()
            .getArray();
      }
      for(let l of layers) {
        let full_type = l.get("full_type");
        if(ignore_data && type === "data" && full_type.indexOf('@') > -1) {
          //ignoruje podzaił w warstwach data, ze zbioru kanalizacyjnych
          full_type = l.get("full_type").split('@')[0];
        }
        if(full_type === layername) return l;
      }
    },
    toggleLayer(layername, value, type, ignore_data = false) {
      // Przełączanie widoczności warstwy danych
      let layer;
      let new_type = type;
      if(type) {
        layer = this.selectLayerByName(layername, type, ignore_data);
      } else {
        let types = ["data", "additional", "wms", "user", "temp", "sketche"];
        while(!layer && types.length > 0) {
          new_type = types.shift();
          layer = this.selectLayerByName(layername, new_type, ignore_data);
        }
      }
      if(!layer) {
        //console.log("brak takowej warstwy", layername, value, type);
        this.$root.$emit("toggleLayerEnd", layername, false);
        return;
      }
      if(typeof value === "undefined") {
        layer.setVisible(!layer.getVisible());
      } else if(layer.getVisible() !== value) {
        layer.setVisible(value);
      } else {
        //warstwa właczona
        this.$root.$emit("toggleLayerEnd", layername, false);
        return;
      }
      if(
        ["data", "additional", "user", "temp", "sketche", "wms"].includes(
          new_type
        )
      ) {
        this.$store.commit("setVisibleLayer", {
          layer: layername,
          visible: layer.getVisible(),
          instance: this.$root.createProxy(layer)
        });
        this.$store.commit("saveVisibleLayers");
      }
      this.$root.$emit("toggleLayerEnd", layername, true);
    },
    findFeatureById(id, layername, type) {
      let layer;
      let new_type = type;
      if(type) {
        layer = this.selectLayerByName(layername, type);
      } else {
        let types = ["data", "additional", "user", "temp", "sketche"];
        while(!layer && types.length > 0) {
          new_type = types.shift();
          layer = this.selectLayerByName(layername, new_type);
        }
      }
      if(!layer || !(layer instanceof VectorLayer)) {
        return false;
      }

      const source = layer.getSource();
      let result;
      source.forEachFeature(feature => {
        if(feature.getId() === id) {
          result = feature;
          return true;
        }
      });
      return result;
    },
    updateLayerFields(layerType, fields) {
      const layer = this.selectLayerByName(layerType, 'data', true);
      if (layer) {
        layer.set('fields', fields);
      } else {
        console.log(`updateLayerFields, nie znaleziono '${layerType}'`);
      }
    },

    switchBasemapByName(basemap) {
      for(let l of this.baselayers.filter(b => b.type === "basemap")) {
        l.instance.setVisible(l.display_name === basemap);
      }
    },

    getAppLayers() {
      // "Warstwy dodatkowe"
      this.$store.dispatch("getAppLayers").then(r => {
        if(!r) {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Błąd pobierania warstw dodatkowych"
          );
        } else {
          this.loadAppLayers();
        }
      });
    },
    getAppLayersMeta() {
         // "Warstwy dodatkowe - metadane"
      this.$store.dispatch('getAppLayersMeta').then(r => {
        if(!r) {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Błąd pobierania metadanych warstw dodatkowych"
          );
        }
      })
    },
    getBaselayers() {
      this.$store.dispatch("getBaselayers").then(r => {
        if(!r) {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Błąd pobierania warstw podkładowych"
          );
        } else {
          this.loadBaselayers();
        }
        this.setBasemapOpacity(this.basemapOpacity);
      });
    },
    loadAppLayers() {
      for(let l of this.appLayers) {
        let layer = undefined;
        if(l.name === `${this.geoportalName}:granice_dzialek`) {
          const urlParams = {
            REQUEST: "GetTile",
            SERVICE: "WMTS",
            VERSION: "1.0.0",
            LAYER: l.name,
            STYLE: "",
            TILEMATRIX: "EPSG:2180:{z}",
            TILEMATRIXSET: "EPSG:2180",
            FORMAT: "application/x-protobuf;type=mapbox-vector",
            TILECOL: "{x}",
            TILEROW: "{y}"
          };
          let url = `${l.url}?`;
          for(let param in urlParams) {
            url = `${url}${param}=${urlParams[param]}&`;
          }

          const style = new Style({
            stroke: new Stroke({
              color: "#ff0000",
              width: 1
            }),
            text: new Text({
              font: "10px sans-serif",
              color: "#ff0000",
              text: "",
              textAlign: "center",
              textBaseline: "middle",
              placement: "point",
              overflow: false,
              fill: new Fill({
                color: "#ff0000"
              })
            })
          });

          layer = new VectorTileLayer({
            source: new VectorTileSource({
              url: url,
              layer: l.name,
              matrixSet: "EPSG:2180",
              format: new MVT({}),
              tileGrid: this.wmtsTilegrid
            }),
            name: l.name,
            full_name: l.display_name,
            type: "app_layer",
            full_type: `app_layer_${l.name}`,
            visible: false,
            style(feature) {
              style.getText().setText(feature.get("nr_dzialka"));
              return style;
            }
          });
          layer.getFeatureId = function (feature) {
            return feature.get("ogc_fid");
          };
          layer.getFeatureProperties = function (feature) {
            let geometry;
            try {
              geometry = new GeoJSON().readGeometry(feature.get("wkb_json"));
            } catch(e) {
              console.log(e);
            }
            return {
              id: feature.get("ogc_fid"),
              ogc_fid: feature.get("ogc_fid"),
              nr_dzialka: feature.get("nr_dzialka"),
              nazwa_obre: feature.get("nazwa_obre"),
              nr_obreb: feature.get("nr_obreb"),
              teryt: feature.get("identyfika"),
              geometry,
            };
          };
        } else {
          layer = new TileLayer({
            source: new WMTS({
              url: l.url,
              layer: l.name,
              matrixSet: "EPSG:2180",
              format: "image/png",
              tileGrid: this.wmtsTilegrid
            }),
            name: l.name,
            full_name: l.display_name,
            type: "app_layer",
            full_type: `app_layer_${l.name}`,
            visible: false
          });
        }
        this.map
          .getLayers()
          .item(0)
          .getLayers()
          .push(layer);
      }
    },
    loadBaselayers() {
      let layers = [];

      for(let baselayer of this.baselayers) {
        let layer;
        if(baselayer.type === "xyz") {
          layer = new TileLayer({
            source: new XYZ({
              url: baselayer.url
            }),
            name: baselayer.name,
            type: "basemap",
            visible: false
          });
        } else if(baselayer.type === "wmts") {
          layer = new TileLayer({
            source: new WMTS({
              url: baselayer.url,
              layer: baselayer.name,
              matrixSet: "EPSG:2180",
              format: "image/png",
              tileGrid: this.wmtsTilegrid
            }),
            name: baselayer.name,
            type: "basemap",
            visible: false
          });
        } else if(baselayer.type === "geoportal") {
          layer = new TileLayer({
            source: new WMTS({
              url: baselayer.url,
              layer: 'ORTOFOTOMAPA',
              style: 'default',
              matrixSet: 'EPSG:2180',
              format: 'image/jpeg',
              tileGrid: this.wmtsTilegridGeoportal,
              wrapX: true,
            }),
            name: baselayer.name,
            type: 'basemap',
            visible: false
          });
        }
        if(layer === undefined) continue;

        layers.push({
          name: baselayer.name,
          display_name: baselayer.display_name,
          type: "basemap",
          instance: this.$root.createProxy(layer)
        });
      }

      // Empty/blank layer
      let empty = new TileLayer({
        name: "Brak",
        type: "basemap",
        visible: false
      });
      layers.push({
        name: "brak",
        display_name: "Brak",
        type: "basemap",
        instance: this.$root.createProxy(empty)
      });

      this.map
        .getLayers()
        .item(0)
        .getLayers()
        .extend(_.map(layers, l => l.instance.__value));
      this.$store.commit("setBaselayers", layers);
    },

    //<editor-fold defaultstate="collapsed" desc="user layers">
    getUserLayers() {
      // "Warstwy dodatkowe"
      this.$store.dispatch("getUserLayers").then(r => {
        if(!r) {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Błąd pobierania warstw użytkownika"
          );
        } else {
          this.loadUserLayers();
          this.$store.dispatch("getUsersRasters").then(r => {
            _(r.layers)
              .filter(layer => !!layer.coverage_name)
              .each(layer => {
                const extent = [
                  layer.extent.xmin,
                  layer.extent.ymin,
                  layer.extent.xmax,
                  layer.extent.ymax
                ];
                this.addRasterLayer(
                  layer.coverage_name,
                  layer.url,
                  layer.public,
                  layer.title,
                  layer.id,
                  extent,
                  false,
                  layer.raster_type,
                );
              })
              .value();
          });
        }
      });
    },
    loadUserLayers() {
      for(let l of this.userLayers) {
        this.addUserLayer(l);
      }
    },
    loadUserLayerData(e, fitToExtent = false) {
      const layer = e.target;
      const params = {
        layername: layer.get("table"),
        srid: "2180"
      };
      return new Promise((resolve, reject) => {
        this.$store.dispatch("getUserLayerFeatures", params).then(r => {
          if(!r) {
            this.$root.$emit(
              "showSnackbar",
              "red",
              'Błąd ładowania obiektów warstwy "' + layer.get("table") + '"'
            );
            reject();
          } else {
            const source = layer.getSource();
            const features = new GeoJSON().readFeatures(r);
            this.snapMeasureFeatures.extend(features);
            source.addFeatures(features);

            if(fitToExtent) {
              this.map.getView().fit(source.getExtent(), {duration: 1000});
            }
            resolve();
          }
        });
      });
    },
    addUserLayer(l, declaration = false) {
      const source = new VectorSource({
        features: new Collection(),
        id: `source_user_${l.table}`
      });
      const vlayer = new VectorLayer({
        source,
        id: `user_${l.table}`,
        visible: false,
        fields: l.fields,
        full_type: `user_layer_${l.table}`,
        type: "user_layer",
        full_name: `user_layer_${l.table}`
      });

      if("user_layers" in this.styles && l.table in this.styles.user_layers) {
        if (declaration) {
          //jeżeli stylizację dla nowych warstw
          this.$store.commit("removeSingleStyles", `user_layers.${l.table}`);
        } else {
          if (this.styles.user_layers[l.table].geometryType !== l.geometry_type) {
            //jeżeli ustawiony styl dla warstwy jest innego typu geometrii to usuń
            this.$store.commit("removeSingleStyles", `user_layers.${l.table}`);
          }
        }
      }

      if("user_layers" in this.styles && l.table in this.styles.user_layers) {
        const origStyle = this.styles.user_layers[l.table];
        let styleObject = this.createLayerStyle(l.table, origStyle, {
          fields: this.fieldsToMap(l.fields)
        });
        if(!styleObject) {
          console.log(`Błedna stylizacja lub klucz dla '${l.table}'`);
          styleObject = () => ([]);
        }
        vlayer.setStyle(styleObject);

        vlayer.setMaxResolution(
          this.map.getView()
            .getResolutionForZoom(origStyle ? (origStyle.minzoom || 0) : 0),
        );
      } else {
        vlayer.setStyle(undefined);
      }

      Object.keys(l).forEach(prop => {
        vlayer.set(prop, l[prop]);
      });
      vlayer.once("change:visible", e =>
        this.loadUserLayerData(e, declaration)
      );
      vlayer.forceRefresh = () => {
        source.clear(true);
        this.loadUserLayerData({
          target: vlayer
        });
      };

      this.map
        .getLayers()
        .item(1) //warstwy różne
        .getLayers()
        .item(0) //warstwy użtkownika
        .getLayers()
        .push(vlayer);

      this.$store.commit("setLayerInstance", {
        layer: vlayer.get("full_type"),
        instance: this.$root.createProxy(vlayer)
      });
      if(declaration) {
        this.$root.$emit("addedUserLayer", `user_layer_${l.table}`); //ustawia obserwowanie zmiany addUserLayer
        l.geometry_type = gu.toGeometryType(l.geometry_type);
        this.$store.commit("addUserLayer", l);
      }
    },
    updateUserLayer(table, data) {
      const self = this;

      const orginal = _.find(self.userLayers, layer => layer.table === table);
      orginal.fields = data.fields;
      orginal.name = data.name;
      orginal.public = data.public;
      this.$store.commit("setUserLayer", {
        table,
        layer: orginal
      });

      const vlayer = self.layersInstance[`user_layer_${table}`].__value;
      vlayer.set("fields", orginal.fields);
      vlayer.set("name", orginal.name);
      vlayer.set("public", orginal.public);
      vlayer.forceRefresh();
    },

    //tymczasowe
    addTempLayer(layer, features, visible = false, style = undefined) {
      const source = new VectorSource({
        features: new Collection(),
        id: `source_temp_${layer.name}_${layer.id}`
      });
      source.addFeatures(features);

      const vlayer = new VectorLayer({
        source,
        id: `temp_${layer.name}_${layer.id}`,
        visible: visible,
        fields: layer.fields,
        full_type: `temp_layer_${layer.name}_${layer.id}`,
        type: "temp_layer",
        full_name: `temp_layer_${layer.name}`
      });

      if(style) {
        vlayer.setStyle(style);
      }

      Object.keys(layer).forEach(prop => {
        vlayer.set(prop, layer[prop]);
      });
      this.map
        .getLayers()
        .item(1) //warstwy rózne
        .getLayers()
        .item(1) //warstwy tymczasowe
        .getLayers()
        .push(vlayer);

      this.$store.commit("setLayerInstance", {
        layer: vlayer.get("full_type"),
        instance: this.$root.createProxy(vlayer)
      });

      if(visible) {
        this.$store.commit("setVisibleLayer", {
          layer: `temp_layer_${layer.name}_${layer.id}`,
          visible: true,
          instance: this.$root.createProxy(layer)
        });
      }
    },
    //</editor-fold>

    //<editor-fold defaultstate="collapsed" desc="sketches">
    getSketches() {
      // "Warstwy dodatkowe"
      this.$store.dispatch("getSketches").then(r => {
        if(!r) {
          this.$root.$emit("showSnackbar", "red", "Błąd pobierania szkiców");
        } else {
          this.loadSketches();
        }
      });
    },
    loadSketches() {
      for(let l of this.sketchesLayers) {
        const source = new VectorSource({
          features: new Collection(),
          id: "source_sketche_" + l.id
        });

        const vlayer = new VectorLayer({
          source,
          id: l.id,
          visible: false,
          fields: [],
          full_type: `sketche_layer_${l.id}`,
          type: "sketche_layer",
          full_name: `sketche_layer_${l.id}`
        });

        Object.keys(l).forEach(prop => {
          vlayer.set(prop, l[prop]);
        });
        vlayer.once("change:visible", this.loadSketcheLayerData);
        this.map
          .getLayers()
          .item(1) //warstwy rózne
          .getLayers()
          .item(2) //warstwy szkicy
          .getLayers()
          .push(vlayer);

        this.$store.commit("setLayerInstance", {
          layer: vlayer.get("full_type"),
          instance: this.$root.createProxy(vlayer)
        });
      }
    },
    loadSketcheLayerData(e) {
      const self = this;
      const layer = e.target;
      self.$store
        .dispatch("getSketcheFeatures", {
          id: layer.get("id")
        })
        .then(r => {
          if(!r) {
            self.$root.$emit(
              "showSnackbar",
              "red",
              'Błąd ładowania obiektów warstwy "' + layer.get("name") + '"'
            );
          } else {
            const source = layer.getSource();
            const features = new GeoJSON({
              featureProjection: self.$root.projection,
              dataProjection: "EPSG:4326"
            }).readFeatures(r);
            //self.snapMeasureFeatures.extend(features);
            source.addFeatures(features);
          }
        });
    },
    //</editor-fold>

    addLayer(layer) {
      //dodawanie warstwy danych
      layer.once("change", e => {
        this.tmpCounter++;
        if(this.tmpCounter === this.visibleLayersCounter) {
          // document.getElementById("loader").style.display = "none";
          document.getElementsByClassName("wrapper__viewer")[0].style.opacity = "1";
        }
      });
      if(!this.visibleLayers.hasOwnProperty(layer.get("full_type"))) {
        this.$store.commit("setVisibleLayer", {
          layer: layer.get("full_type"),
          visible: false
        });
      }
      layer.set("id", "default_" + layer.get("full_type"));
      if(layer.get("type") !== "app_layer") {
        layer.once("change:visible", e => {
          layer.getSource().clear(true); //wyczyść pozostałości po edycji
          this.loadData(e);
        });
        layer.forceRefresh = () => {
          layer.getSource().clear(true);
          this.loadData({
            target: layer
          });
        };
      }
      this.map
        .getLayers()
        .item(2)
        .getLayers()
        .push(layer);

      this.$store.commit("setLayerInstance", {
        layer: layer.get("full_type"),
        instance: this.$root.createProxy(layer)
      });
    },
    addRasterLayer(
      id,
      url,
      _public,
      name,
      geoserwer_id = -1,
      extent = [],
      visible = true,
      raster_type = null,
    ) {
      const layer = new TileLayer({
        source: new WMTS({
          url,
          layer: `${this.geoportalName}:${id}`,
          matrixSet: "EPSG:2180",
          format: "image/png",
          tileGrid: this.wmtsTilegrid
        }),

        name,
        id: `user_${id}`,
        full_name: `user_layer_${id}`,
        type: "user_layer",
        full_type: `user_layer_${id}`,
        geoserwer_id,
        visible
      });

      if(raster_type === "dem") {
        layer.setOpacity(0.65);
      }

      this.map
        .getLayers()
        .item(1) //warstwy różne
        .getLayers()
        .item(0) //warstwy użtkownika
        .getLayers()
        .push(layer);

      this.$store.commit("addUserRasterLayers", {
        name,
        id: `user_${id}`,
        public: _public,
        full_name: `user_layer_${id}`,
        type: "user_layer",
        full_type: `user_layer_${id}`,
        extent
      });

      this.$store.commit("setLayerInstance", {
        layer: layer.get("full_type"),
        instance: this.$root.createProxy(layer)
      });
    },
    loadData(e) {
      let layer = e.target;
      let geometry_type = layer.get("geometry_type");
      let geometry_read_only = layer.get("geometry_read_only");
      let params = {
        layername: layer.get("type"),
        srid: "2180"
      };
      if(layer.get("net_type")) {
        params.filter = `net_type=${layer.get("net_type")}`;
      }
      if(params.layername === 'watermeters') {
        params.with_geometry = 'true';
      }
      this.$store.dispatch("getFeatures", params).then(r => {
        if(!r) {
          this.$root.$emit(
            "showSnackbar",
            "red",
            `Błąd ładowania obiektów warstwy "${layer.get("full_name")}"`
          );
        } else {
          let source = layer.getSource();
          if(source instanceof Cluster) {
            source = source.getSource();
          }
          const features = new GeoJSON().readFeatures(r);
          if(geometry_type !== "none") {
            gu.geometriyToSimple(features);
            this.snapMeasureFeatures.extend(features);
          } else if(geometry_read_only) {
            gu.geometriyToSimple(features);
          }
          source.addFeatures(features);
        }
      });
    },

    //<editor-fold defaultstate="collapsed" desc="wms">
    addWMSLayer(data, visible = false) {
      const self = this;

      const layer = new TileLayer({
        extent: data.parameters.extent,
        source: new TileWMS({
          url: data.url,
          params: {
            LAYERS: data.parameters.LAYERS,
            TILED: true,
            VERSION: data.parameters.VERSION,
            SRS: data.parameters.SRS,
            CRS: data.parameters.CRS,
            FORMAT: data.parameters.FORMAT
          },
          serverType: "geoserver",
          transition: 0
        }),
        id: data.id,
        full_type: `wms_layer_${data.id}`,
        visible
      });

      self.map
        .getLayers()
        .item(0)
        .getLayers()
        .push(layer);

      self.$store.commit("addWMSLayer", {
        display_name: data.display_name,
        name: data.name,
        id: data.id,
        full_name: `wms_layer_${data.id}`,
        type: "wms_layer",
        full_type: `wms_layer_${data.id}`,
        extent: data.parameters.extent,
        user: data.user
      });

      this.$store.commit("setLayerInstance", {
        layer: layer.get("full_type"),
        instance: this.$root.createProxy(layer)
      });
    },
    getWMSLayers() {
      // "Warstwy wms"
      this.$store.dispatch("getWMSLayers").then(r => {
        if(r === false) {
          this.$root.$emit("showSnackbar", "red", "Błąd pobierania warstw wms");
        } else {
          this.loadWMSLayers(r);
        }
      });
    },
    loadWMSLayers(layers) {
      for(let l of layers) {
        this.addWMSLayer(l);
      }
    },
    //</editor-fold>

    deleteLayer(type, layer) {
      const self = this;

      if(layer instanceof ProxyObserver) {
        layer = layer.__value;
      }

      if(!layer) {
        console.log("deleteLayer", type, layer);
        self.$root.$emit("deletedLayer", type, undefined, false);
        return Promise.resolve(false);
      }

      let layers; //collection

      switch(type) {
        case "additional": //podkładowe
          console.log(
            "Błedna deklaracja usunięcia warstwy dodatkowych, warstwy nieusuwalne",
            typeof layer
          );
          self.$root.$emit("deletedLayer", type, undefined, false);
          return Promise.resolve(false);
        case "wms": //WMS
          layers = self.map
            .getLayers()
            .item(0)
            .getLayers();
          return self.$store
            .dispatch("removeWMSLayer", layer.get("id"))
            .then(res => {
              if(res.status === 200) {
                layers.remove(layer); //usunięcie z OL

                self.$store.commit("deleteWMSLayer", layer.get("id")); //usunięcie z deklaracji

                self.$root.$emit(
                  "showSnackbar",
                  "success",
                  "Pomyślnie usunięto warstwę wms"
                );

                self.$root.$emit("deletedLayer", type, layer.get("id"), true);

                return true;
              } else {
                self.$root.$emit("showSnackbar", "red", `${res.message}`);
                self.$root.$emit("deletedLayer", type, layer.get("id"), false);

                return false;
              }
            });
        case "data": //Wodkan i kanalizacyjne
          layers = self.map
            .getLayers()
            .item(2)
            .getLayers();
          layers.remove(layer); //usunięcie z OL
          self.$store.commit("deleteLayerInstance", layer.get("full_type")); //usunięcie z mapy instancji
          self.$store.commit("deleteLayer", layer.get("full_type")); //usunięcie z deklaracji

          self.$root.$emit(
            "showSnackbar",
            "success",
            "Pomyślnie usunięto warstwę danych, tylko z widoku"
          );

          self.$root.$emit("deletedLayer", type, layer.get("full_type"), true);
          return Promise.resolve(true);
        case "user": //użytkownika wektorowe i rastrowe
          layers = self.map
            .getLayers()
            .item(1)
            .getLayers()
            .item(0)
            .getLayers();

          if(layer instanceof VectorLayer) {
            //wektorowe
            return self.$store
              .dispatch("removeUserLayer", layer.get("table"))
              .then(res => {
                if(res.status === 200) {
                  layers.remove(layer); //usunięcie z OL

                  self.$store.commit("deleteLayerInstance", layer.get("full_type")); //usunięcie z mapy instancji
                  self.$store.commit("deleteUserLayer", layer.get("table")); //usunięcie z deklaracji

                  self.$root.$emit(
                    "showSnackbar",
                    "success",
                    "Pomyślnie usunięto warstwę użytkownika"
                  );

                  self.$root.$emit("deletedLayer", type, layer.get("full_type"), true);

                  return true;
                } else {
                  self.$root.$emit("showSnackbar", "red", `${res.message}`);
                  self.$root.$emit("deletedLayer", type, layer.get("full_type"), false);

                  return false;
                }
              });
          } else if(layer instanceof TileLayer) {
            //rastrowe
            return self.$store
              .dispatch("removeUserRasterLayer", layer.get("geoserwer_id"))
              .then(res => {
                if(res.status === 200) {
                  layers.remove(layer); //usunięcie z OL

                  self.$store.commit("deleteUserRasterLayer", layer.get("id")); //usunięcie z deklaracji

                  self.$root.$emit(
                    "showSnackbar",
                    "success",
                    "Pomyślnie usunięto warstwę użytkownika"
                  );

                  self.$root.$emit("deletedLayer", type, layer.get("id"), true);

                  return true;
                } else {
                  self.$root.$emit("showSnackbar", "red", `${res.message}`);
                  self.$root.$emit("deletedLayer", type, layer.get("id"), false);

                  return false;
                }
              });
          }

          console.log(
            "Błedna deklaracja usunięcia warstwy użytkownika",
            typeof layer
          );
          self.$root.$emit("deletedLayer", type, undefined, false);
          return Promise.resolve(false);
        case "temp": //tymczasowe
          layers = self.map
            .getLayers()
            .item(1)
            .getLayers()
            .item(1)
            .getLayers();
          layers.remove(layer); //usunięcie z OL
          self.$store.commit("deleteLayerInstance", layer.get("full_type")); //usunięcie z mapy instancji
          self.$store.commit("deleteTempLayer", {
            name: layer.get("name"),
            id: layer.get("id")
          }); //usunięcie z deklaracji
          self.$root.$emit(
            "showSnackbar",
            "success",
            "Pomyślnie usunięto warstwę tymczasową"
          );
          self.$root.$emit("deletedLayer", type, layer.get("full_type"), true);
          return Promise.resolve(true);
        case "sketche": //szkice
          layers = self.map
            .getLayers()
            .item(1)
            .getLayers()
            .item(2)
            .getLayers();

          return self.$store
            .dispatch("removeSketcheLayer", layer.get("id"))
            .then(res => {
              if(res.status === 200) {
                layers.remove(layer); //usunięcie z OL

                self.$store.commit("deleteLayerInstance", layer.get("full_type")); //usunięcie z mapy instancji
                self.$store.commit("deleteSketche", layer.get("id")); //usunięcie z deklaracji

                self.$root.$emit(
                  "showSnackbar",
                  "success",
                  "Pomyślnie usunięto warstwę użytkownika"
                );

                self.$root.$emit("deletedLayer", type, layer.get("id"), true);

                return true;
              } else {
                self.$root.$emit("showSnackbar", "red", `${res.message}`);
                self.$root.$emit("deletedLayer", type, layer.get("id"), false);

                return false;
              }
            });
        default:
          console.log(
            "Błedna deklaracja usunięcia typu warstwy do usunięcia",
            type
          );
          self.$root.$emit("deletedLayer", type, undefined, true);
          return Promise.resolve(false);
      }
    },

    //<editor-fold defaultstate="collapsed" desc="styles">
    getEditStyleSquartes(feature, color) {
      let geometry = feature.getGeometry();

      if(geometry.getType() === "LineString") {
        geometry = new MultiPoint(geometry.getCoordinates());
      } else if(geometry.getType() === "Polygon") {
        geometry = new MultiPoint(geometry.getCoordinates()[0]);
      } else {
        return false;
      }

      const style = new Style({
        image: new RegularShape({
          radius: 7,
          fill: new Fill({
            color: "rgba(255, 255, 255, 0.3)"
          }),
          stroke: new Stroke({
            color: color.concat([0.6]),
            width: 2
          }),
          points: 4,
          angle: Math.PI / 2
        }),

        geometry
      });
      return style;
    },
    getSelectedStyle() {
      if(!this.defaultSelectedStyles) {
        const fill = new Fill({
          color: "rgba(255, 242, 0, 0.4)"
        });
        const stroke = new Stroke({
          color: "rgba(255, 242, 0, 0.6)",
          width: 10
        });
        const fill2 = new Fill({
          color: "rgba(255, 255, 255, 0.4)"
        });
        const stroke2 = new Stroke({
          color: "rgba(255, 255, 255, 0.6)",
          width: 12
        });
        this.defaultSelectedStyles = [
          new Style({
            image: new Circle({
              fill: fill2,
              stroke: stroke2,
              radius: 12
            }),
            fill: fill2,
            stroke: stroke2
          }),
          new Style({
            image: new Circle({
              fill: fill,
              stroke: stroke,
              radius: 10
            }),
            fill: fill,
            stroke: stroke
          })
        ];
      }
      return this.defaultSelectedStyles;
    },
    getModyficationStyle() {
      if(!this.defaultModyficationStyles) {
        const fill = new Fill({
          color: "rgba(0, 0, 0, 0.2)"
        });
        const stroke = new Stroke({
          color: "rgba(255, 0, 0, 0.4)",
          width: 6
        });
        this.defaultModyficationStyles = [
          new Style({
            image: new Circle({
              fill: fill,
              stroke: stroke,
              radius: 8
            }),
            fill: fill,
            stroke: stroke
          })
        ];
      }
      return this.defaultModyficationStyles;
    },
    getAllowSelectStyle() {
      if(!this.defaultAllowSelectStyles) {
        const fill = new Fill({
          color: "rgba(0, 255, 0, 0.4)"
        });
        const stroke = new Stroke({
          color: "rgba(0, 255, 0, 0.6)",
          width: 8
        });
        this.defaultAllowSelectStyles = [
          new Style({
            image: new Circle({
              fill: fill,
              stroke: stroke,
              radius: 6
            }),
            fill: fill,
            stroke: stroke
          })
        ];
      }
      return this.defaultAllowSelectStyles;
    },
    pointRadiusFromZoom(feature, iconSize = 1) {
      if(this.getZoom() >= 18) {
        return iconSize * 0.5;
      } else if(this.getZoom() >= 15) {
        return iconSize * 0.25;
      } else {
        return iconSize * 0.125;
      }
    },
    getText(feature, type, geometryType, labels, fields) {
      if(labels.length === 0) {
        return "";
      }

      let label = _(labels)
        .map(label => {
          let label_value = feature.get(label);
          const field = fields[label];

          if(
            label_value !== undefined &&
            label_value !== null &&
            field &&
            label_value in field
          ) {
            label_value = `${field[label_value].value || ""}`;
          } else if(label_value !== undefined && label_value !== null) {
            label_value = `${label_value}`;
          } else {
            label_value = "";
          }
          return label_value;
        })
        .join(" ")
        .value()
        .trim();

      return label;
    },
    createTextStyle(feature, type, geometryType, labels, fields) {
      if(!this.labelsShow) {
        return undefined;
      }

      const text = this.getText(feature, type, geometryType, labels, fields);
      if(!text || text === "") {
        return undefined;
      }

      const def = {
        textAlign: "center",
        textBaseline: "middle",
        font: `Normal 12px Open Sans`,
        text,
        fill: new Fill({
          color: "white"
        }),
        stroke: new Stroke({
          color: "black",
          width: 3
        }),
        overflow: false
      };

      if(geometryType === "line") {
        def.placement = "line";
      } else if(geometryType === "point") {
        def.placement = "point";
        def.textAlign = "end";
        def.textBaseline = "top";
        def.offsetX = 5;
        def.offsetY = 5;
      } else {
        def.placement = "point";
      }

      return new Text(def);
    },
    createClusterStyle(styleObject) {
      const styleCache = {};

      return (feature, resolution) => {
        const size = feature.get('features').length;

        if(size === 1) {
          return styleObject(feature, resolution);
        }

        let style = styleCache[size];
        if(!style) {
          style = new Style({
            image: new Circle({
              radius: 10,
              stroke: new Stroke({
                color: '#fff'
              }),
              fill: new Fill({
                color: '#3399CC'
              })
            }),
            text: new Text({
              text: size.toString(),
              fill: new Fill({
                color: '#fff'
              })
            })
          });
          styleCache[size] = style;
        }
        return [style];
      };
    },
    createArrowStyle(geom, resolution, layer_type) {
      if(geom.getLength() / resolution < 30) return null;
      /*
       * 30 wypada w miare optymalnie,
       * zmniejszenie wartości powoduje większą ilość strzałek
       * zwiększenie ogranicza ją
       */
      if(!layer_type.endsWith('_sewers')) return null;
      //tylko kanalizacyjne

      const zoom = this.map.getView().getZoomForResolution(resolution);
      const coords = geom.getCoordinates();
      const dx = coords[coords.length - 1][0] - coords[0][0];
      const dy = coords[coords.length - 1][1] - coords[0][1];
      const rotation = -Math.atan2(dy, dx);

      let scale = 1;
      if(zoom < 15) {
        scale = 0.5;
      } else if(zoom < 18) {
        scale = 0.75;
      }

      return new Style({
        geometry: new Point(geom.getFlatMidpoint()),
        image: new Icon({
          src: require(`../../../assets/map_icons/arrow_black.svg`),
          anchor: [0.5, 0.5],
          rotateWithView: true,
          scale,
          rotation
        })
      });
    },
    createValvesStateStyle(feature, resolution) {
      let state = `${feature.get('state')}`;
      const zoom = this.map.getView().getZoomForResolution(resolution);

      state = state.trim();
      if(!(state in valvesStateIcons)) {
        state = 'NULL';
      };

      let scale = 1;
      if(zoom < 15) {
        scale = 0.5;
      } else if(zoom < 18) {
        scale = 0.75;
      }

      return new Style({
        image: new Icon({
          src: valvesStateIcons[state],
          anchor: [0.5, 0.5],
          scale,
        }),
        zIndex: 100
      });
    },
    createLayerStyle(layertype, originalStyle, {fields = {}} = {}) {
      const self = this;
      if(!originalStyle) {
        return false;
      }
      const geometryType = originalStyle.geometryType;

      function getStopOrUndefined(feature, key, _default = undefined) {
        if(!(key in originalStyle)) {
          return _default;
        }
        const style = originalStyle[key];
        const value = style.stops.find(
          el => el[0] === feature.get(style.property)
        );
        if(value === undefined) {
          return _default;
        }
        return value[1];
      }
      function mixAlphaColor(color, opacity = 1) {
        if(color) {
          if("#ff77900" === color) color = "#ff7900"; //fix bład w danych kolor powinien mieć 6 znaków
          try {
            color = asArrayColor(color).slice(0, 3);
          } catch(ex) {
            console.log(`Błedny kod koloru w CSS`, color);
            return [0, 0, 0, 0];
          }
        } else {
          return [0, 0, 0, 0];
        }
        color.push(opacity || 1);
        return color;
      }
      function getAlphaColor(style, keyColor, keyOpacity) {
        return mixAlphaColor(style[keyColor], style[keyOpacity]);
      }

      if(
        "uniqueColor" in originalStyle ||
        "uniqueWidth" in originalStyle ||
        "uniqueGap" in originalStyle ||
        "uniqueRadius" in originalStyle
      ) {
        if(originalStyle.geometryType === "line") {
          return (feature, resolution) => {
            const styles = [
              new Style({
                stroke: new Stroke({
                  color: mixAlphaColor(
                    getStopOrUndefined(
                      feature,
                      "uniqueColor",
                      originalStyle["line-color"]
                    ),
                    originalStyle["fill-opacity"]
                  ),
                  width: getStopOrUndefined(
                    feature,
                    "uniqueWidth",
                    originalStyle["line-width"]
                  ),
                  lineDash: originalStyle["line-dash"] //getStopOrUndefined(feature, "uniqueGap", )
                }),
                text: self.createTextStyle(
                  feature,
                  layertype,
                  geometryType,
                  originalStyle.labels || [],
                  fields
                )
              })
            ];

            if(resolution && self.showDirectionFlows) {
              const arrowStyle = self.createArrowStyle(feature.getGeometry(), resolution, layertype);
              if(arrowStyle) {
                styles.push(arrowStyle);
              }
            }

            return styles;
          };
        } else if(originalStyle.geometryType === "point") {
          return (feature, resolution) => {
            const styles = [
              new Style({
                image: new Circle({
                  fill: new Fill({
                    color: mixAlphaColor(
                      getStopOrUndefined(
                        feature,
                        "uniqueColor",
                        originalStyle["circle-color"]
                      ),
                      originalStyle["fill-opacity"]
                    )
                  }),
                  radius: getStopOrUndefined(
                    feature,
                    "uniqueRadius",
                    originalStyle["circle-radius"]
                  )
                }),
                text: self.createTextStyle(
                  feature,
                  layertype,
                  geometryType,
                  originalStyle.labels || [],
                  fields
                )
              })
            ];

            if(resolution && layertype === 'valves' && self.showValvesState) {
              const valvesStateStyle = self.createValvesStateStyle(feature, resolution);
              if(valvesStateStyle) {
                styles.push(valvesStateStyle);
              }
            }

            return styles;
          };
        } else if(originalStyle.geometryType === "polygon") {
          return feature => {
            return [
              new Style({
                fill: new Fill({
                  color: mixAlphaColor(
                    getStopOrUndefined(
                      feature,
                      "uniqueColor",
                      originalStyle["fill-color"]
                    ),
                    originalStyle["fill-opacity"]
                  )
                }),
                text: self.createTextStyle(
                  feature,
                  layertype,
                  geometryType,
                  originalStyle.labels || [],
                  fields
                )
              })
            ];
          };
        }
      } else {
        if(geometryType === "line") {
          const stroke = new Stroke({
            color: getAlphaColor(originalStyle, "line-color", "fill-opacity"),
            width: originalStyle["line-width"],
            lineDash: originalStyle["line-dash"] || undefined
          });
          const style = new Style({
            stroke
          });

          return (feature, resolution) => {
            style.setText(
              self.createTextStyle(
                feature,
                layertype,
                geometryType,
                originalStyle.labels || [],
                fields
              )
            );

            const styles = [style];
            if(resolution && self.showDirectionFlows) {
              const arrowStyle = self.createArrowStyle(feature.getGeometry(), resolution, layertype);
              if(arrowStyle) {
                styles.push(arrowStyle);
              }
            }

            return styles;
          };
        } else if(geometryType === "point") {
          if("externalGraphic" in originalStyle) {
            const style = new Style({
              image: new Icon({
                //src: require(`../../../assets/map_icons/${originalStyle.externalGraphic}`),
                src: `${self.$store.getters.getApiURL}/static/map_icons/${
                  originalStyle.externalGraphic
                  }`,
                scale: 1,
                opacity: originalStyle["fill-opacity"] || undefined
              })
            });

            return (feature, resolution) => {
              style
                .getImage()
                .setScale(
                  self.pointRadiusFromZoom(
                    feature,
                    originalStyle["icon-size"] || 1
                  )
                );
              style.setText(
                self.createTextStyle(
                  feature,
                  layertype,
                  geometryType,
                  originalStyle.labels || [],
                  fields
                )
              );

              const styles = [style];
              if(resolution && layertype === 'valves' && self.showValvesState) {
                const valvesStateStyle = self.createValvesStateStyle(feature, resolution);
                if(valvesStateStyle) {
                  styles.push(valvesStateStyle);
                }
              }

              return styles;
            };
          } else {
            const fill = new Fill({
              color: getAlphaColor(
                originalStyle,
                "circle-color",
                "fill-opacity"
              )
            });
            const style = new Style({
              image: new Circle({
                fill,
                radius: originalStyle["circle-radius"] || undefined,
                opacity: originalStyle["fill-opacity"] || undefined
              })
            });
            return (feature, resolution) => {
              style.setText(
                self.createTextStyle(
                  feature,
                  layertype,
                  geometryType,
                  originalStyle.labels || [],
                  fields
                )
              );

              const styles = [style];
              if(resolution && layertype === 'valves' && self.showValvesState) {
                const valvesStateStyle = self.createValvesStateStyle(feature, resolution);
                if(valvesStateStyle) {
                  styles.push(valvesStateStyle);
                }
              }

              return styles;
            };
          }
        } else if(geometryType === "polygon") {
          const stroke = new Stroke({
            color: getAlphaColor(
              originalStyle,
              "fill-outline-color",
              "fill-outline-opacity"
            ),
            width: originalStyle["line-width"],
            lineDash: originalStyle["line-dash"] || undefined
          });
          const fill = new Fill({
            color: getAlphaColor(originalStyle, "fill-color", "fill-opacity")
          });
          const style = new Style({
            fill,
            stroke
          });

          return feature => {
            style.setText(
              self.createTextStyle(
                feature,
                layertype,
                geometryType,
                originalStyle.labels || [],
                fields
              )
            );
            return [style];
          };
        }
      }
    },

    updateStyles() {
      for(let l of this.layersWater) {
        const origStyle = this.styles.layers[l.type];
        //delete origStyle.style_id;
        let styleObject = this.createLayerStyle(l.type, origStyle, {
          fields: this.fieldsToMap(l.fields)
        });
        if(!styleObject) {
          console.log(`Błedna stylizacja lub klucz dla '${l.type}'`);
          styleObject = () => ([]);
        }

        if(l.type === "watermeters") {
          styleObject = this.createClusterStyle(styleObject);
        }

        const layer = this.selectLayerByName(l.full_type, "data");
        if(layer) {
          layer.setStyle(styleObject);

          layer.setMaxResolution(
            this.map.getView()
              .getResolutionForZoom(origStyle ? (origStyle.minzoom || 0) : 0),
          );
        }
      }

      for(let l of this.layersSewer) {
        //delete this.styles.layers[l.type].style_id;
        const origStyle = this.styles.layers[l.type][l.net_type];
        let styleObject = this.createLayerStyle(l.type, origStyle, {
          fields: this.fieldsToMap(l.fields)
        });
        if(!styleObject) {
          console.log(`Błedna stylizacja lub klucz dla '${l.net_type}' w '${l.table}'`);
          styleObject = () => ([]);
        }

        const layer = this.selectLayerByName(l.full_type, "data");
        if(layer) {
          layer.setStyle(styleObject);

          layer.setMaxResolution(
            this.map.getView()
              .getResolutionForZoom(origStyle ? (origStyle.minzoom || 0) : 0),
          );
        }
      }

      for(let l of this.userLayers) {
        const layer = this.selectLayerByName(`user_layer_${l.table}`, "user");
        if(
          layer &&
          "user_layers" in this.styles &&
          l.table in this.styles.user_layers
        ) {
          const origStyle = this.styles.user_layers[l.table];
          let styleObject = this.createLayerStyle(l.table, origStyle, {
            fields: this.fieldsToMap(l.fields)
          });
          if(!styleObject) {
            console.log(`Błedna stylizacja lub klucz dla '${l.table}'`);
            styleObject = () => ([]);
          }
          layer.setStyle(styleObject);

          layer.setMaxResolution(
            this.map.getView()
              .getResolutionForZoom(origStyle ? (origStyle.minzoom || 0) : 0),
          );
        } else if(layer) {
          layer.setStyle(undefined);
        }
      }
    },
    refreshStyles() {
      for(let l of this.layersWater) {
        if(l.type === "watermeters") continue;
        const layer = this.selectLayerByName(l.full_type, "data");
        if(layer && layer.getVisible()) {
          layer.changed();
        }
      }

      for(let l of this.layersSewer) {
        const layer = this.selectLayerByName(l.full_type, "data");
        if(layer && layer.getVisible()) {
          layer.changed();
        }
      }

      for(let l of this.userLayers) {
        const layer = this.selectLayerByName(l.full_type, "user");
        if(
          layer &&
          "user_layers" in this.styles &&
          l.table in this.styles.user_layers &&
          layer.getVisible()
        ) {
          layer.changed();
        }
      }
    },
    //</editor-fold>

    removeDrawingInteraction() {
      this.map.removeInteraction(this.drawInteraction);
    },
    setPosition(data) {
      if(data.length == 4) {
        this.addMapPoint(data[0], data[1]);
        let point = [data[1], data[0]];
        this.flyTo(point, function () {});
        return;
      }

      this.map.getView().setCenter([data[0], data[1]]);
      this.map.getView().setZoom(data[2]);
    },
    flyTo(location, done) {
      var duration = 2000;
      var zoom = 20;
      var parts = 2;
      var called = false;
      var view = this.map.getView();
      function callback(complete) {
        --parts;
        if(called) {
          return;
        }
        if(parts === 0 || !complete) {
          called = true;
          done(complete);
        }
      }
      view.animate(
        {
          center: location,
          duration: duration
        },
        callback
      );
      view.animate(
        {
          zoom: zoom - 1,
          duration: duration / 2
        },
        {
          zoom: zoom,
          duration: duration / 2
        },
        callback
      );
    },
    clearCutoff() {
      clearInterval(this.valvesInterval);
      clearInterval(this.partitionsInterval);
    },
    showCutoff(data) {
      const self = this;
      if(data.length === 0) return false;
      this.isFirstAnimation = true;
      const duration = 1000;
      this.clearCutoff();
      this.valvesInterval = window.setInterval(
        () =>
          self.flashFeatures(data[0], {
            color: [255, 0, 0],
            duration
          }),
        duration * 3
      );
      this.partitionsInterval = window.setInterval(
        () =>
          self.flashFeatures(data[1], {
            color: [255, 255, 0],
            duration
          }),
        duration * 3
      );
      return true;
    },

    mapRender: _.debounce(function () {
      // w celu mniejszego zacinania strony przy dużej ilości elementów renderowanych
      this.map.render();
    }, 100),
    flashFeatures(features, {duration = 500, color = [255, 0, 0]} = {}, zoom = true) {
      if(features instanceof Feature) {
        features = [features];
      }
      return this.flashGeometries(features.map(f => f.getGeometry()), {
        color,
        duration,
        zoom
      });
    },
    flashGeometries(geometries, {duration = 500, color = [255, 0, 0]} = {}, zoom = true) {
      if(geometries instanceof Geometry) {
        geometries = [geometries];
      } else if(geometries.length === 0) {
        return false;
      }
      const self = this;
      const start = new Date().getTime();
      let listenerKey;

      duration = duration || 500;
      function animate(event) {
        const vectorContext = event.vectorContext;
        const frameState = event.frameState;

        const elapsed = frameState.time - start;
        const elapsedRatio = elapsed / duration;
        const radius = easeOut(elapsedRatio) * 25 + 5;
        const opacity = easeOut(1 - elapsedRatio);

        const style = new Style({
          image: new Circle({
            radius,
            stroke: new Stroke({
              color: `rgba(${color.join(",")}, ${opacity})`,
              width: 0.25 + opacity
            })
          })
        });

        if(vectorContext) {
          vectorContext.setStyle(style);
          for(let geometry of geometries) {
            vectorContext.drawGeometry(new Point(gu.getCenter(geometry, {stick: true})));
          }
        }

        if(elapsed > duration) {
          unByKey(listenerKey);
          return;
        }

        self.mapRender();
      }
      listenerKey = self.map.on("postcompose", animate);

      if (self.isFirstAnimation) {
        self.map.once("moveend", animate);
        if (zoom) {
          self.map.getView().animate({
            zoom: 17,
            duration: 1000
          },{
            center: gu.getCenter(geometries, {stick: true})
          });
        }
      } else {
        self.map.render();
      }
      self.isFirstAnimation = false;

      return true;
    },

    addMarker(data) {
      let marker = require("@/marker.png");

      let vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: [
            new Feature({
              geometry: new Point([data[0], data[1]])
            })
          ]
        }),
        style: new Style({
          image: new Icon({
            anchor: [0.5, 1],
            anchorXUnits: "fraction",
            anchorYUnits: "fraction",
            src: marker
          })
        })
      });
      vectorLayer.set("name", "searchMarker");
      this.map.addLayer(vectorLayer);
    },
    addMapPoint(lat, lng) {
      this.removeMarker();
      this.addMarker([lng, lat]);
    },
    removeMarker() {
      const self = this;
      this.map.getLayers().forEach(layer => {
        if(
          layer.get("name") != undefined &&
          layer.get("name") == "searchMarker"
        ) {
          self.map.removeLayer(layer);
          return;
        }
      });
    },
    addNewLine(data) {
      this.drawInteraction = new Draw({
        source: new VectorSource(),
        type: "LineString",
        style: ces.getCustomStyleFunction([255, 0, 0])
      });
      this.drawInteraction.on("drawend", e => {
        this.payloadGeom = JSON.parse(
          new GeoJSON().writeFeature(e.feature)
        ).geometry;
        this.addMapLayer(
          [this.payloadGeom, this.payloadGeom.coordinates],
          data
        );
        if(data == "print") {
          this.$root.$emit(
            "setPrintLine",
            new WKT().writeGeometry(e.feature.getGeometry())
          );
        }
        this.map.removeInteraction(this.drawInteraction);
        this.drawInteraction = undefined;
      });
      this.map.addInteraction(this.drawInteraction);
    },

    //<editor-fold defaultstate="collapsed" desc="pomiar powierzchni i odległości">
    createMeasureInteraction() {
      const self = this;
      self.measuringTool = new Draw({
        type: "Polygon"
      });

      function measure(geom, end = false) {
        let measurementArea = getArea(geom);
        self.area =
          measurementArea > 1000000
            ? `${(measurementArea / 1000000).toFixed(2)} km<sup>2</sup>`
            : `${measurementArea.toFixed(2)} m<sup>2</sup>`;

        if(!end && geom.getEnds() > 0) {
          let coords = geom.getCoordinates();
          coords = coords[0].slice(0, coords[0].length - 1);
          geom = new LineString(coords);
        }
        let measurementLength = getLength(geom);
        self.length =
          measurementLength > 1000
            ? `${(measurementLength / 1000).toFixed(2)} km`
            : `${measurementLength.toFixed(2)} m`;

        self.$root.$emit("measureData", [self.length, self.area]);
      }

      self.measuringTool.on("drawstart", e => {
        //this.measureSource.clear();
        self.currentMeasurement = e.feature;
        self.currentMeasurement.on("change", evt => {
          measure(evt.target.getGeometry());
        });
      });
      self.measuringTool.on("drawend", evt => {
        const source = self.measureLayer.getSource();
        source.clear();
        source.addFeature(evt.feature);
        measure(evt.feature.getGeometry(), true);
      });

      self.map.addInteraction(self.measuringTool);
      self.measuringTool.setActive(false);
    },
    createSnapMeasure() {
      if(this.snapTolerance > 0) {
        this.snapMeasureInteraction = new Snap({
          features: this.snapMeasureFeatures,
          pixelTolerance: this.snapTolerance
        });
        this.map.addInteraction(this.snapMeasureInteraction);
      } else {
        this.snapMeasureInteraction = false;
      }
    },
    //</editor-fold>

    //<editor-fold defaultstate="collapsed" desc="identyfikacja i zaznaczanie masowe">
    getClosestFeatureToCoordinate(coordinate, features) {
      if(features.length === 0) {
        return null;
      }

      const x = coordinate[0];
      const y = coordinate[1];
      let closestFeature = features[0];
      const closestPoint = [NaN, NaN];
      let minSquaredDistance = Infinity;

      _.each(features, feature => {
        const geometry = feature.getGeometry();
        const previousMinSquaredDistance = minSquaredDistance;
        minSquaredDistance = geometry.closestPointXY(
          x,
          y,
          closestPoint,
          minSquaredDistance
        );
        if(minSquaredDistance < previousMinSquaredDistance) {
          closestFeature = feature;
        }
      });

      return closestFeature;
    },
    getFeaturesAtPixel(pixel, opt_options) {
      const layers = {};
      this.map.forEachFeatureAtPixel(
        pixel,
        (feature, layer) => {
          let key = layer.get("full_type");
          if(opt_options.ignoreDivision) {
            key = key.split('@')[0];
          }
          if(!key) return; //ignore

          const mvt = layer instanceof VectorTileLayer;
          const cluster = !mvt && layer.getSource() instanceof Cluster;

          if(!(key in layers)) {
            layers[key] = {
              name: layer.get("full_name"),
              layer,
              cluster,
              features: [],
              features_cluster: []
            };
          }

          if(mvt) {
            const properties = layer.getFeatureProperties(feature);
            const feature_map = new Feature(properties);
            feature_map.setId(properties.id);
            feature_map.org_feature = feature;
            feature = feature_map;
          } else if(cluster) {
            layers[key].features_cluster.push(...feature.get('features'));
          }
          layers[key].features.push(feature);
        },
        opt_options
      );

      if(opt_options.nearest) {
        const coords = this.map.getCoordinateFromPixel(pixel);
        _.each(layers, layer => {
          if(layer.features.length > 0) {
            layer.features = [
              this.getClosestFeatureToCoordinate(coords, layer.features)
            ];
          }
        });
      }

      return layers;
    },
    highlightFeature(olfeature, add = false) {
      /*this.selectedLayer =  this.map
              .getLayers()
              .item(3)
              .getLayers()
              .item(0);*/
      if(!(olfeature instanceof Feature)) {
        olfeature = new GeoJSON().readFeature(olfeature);
      }

      if(!add) this.selectedLayer.getSource().clear(true);
      this.$store.commit(
        add ? "addCurrentSelectedFeatures" : "setCurrentSelectedFeatures",
        [this.$root.createProxy(olfeature)]);
      this.selectedLayer
        .getSource()
        .addFeature(olfeature);
    },
    configureIdentificationAction() {
      const self = this;
      self.map.on("click", evt => {
        if(!self.identification) return;

        let currentLayer;
        if(self.currentBookmark === "edition") {
          if(!self.currentEditedLayer) {
            self.$root.$emit(
              "showSnackbar",
              "error",
              "Brak wybranej aktywnej warstwy"
            );
            return;
          }

          currentLayer = self.selectLayerByName(self.currentEditedLayer);
          if(!currentLayer) {
            currentLayer = self.selectLayerByName(
              self.currentEditedLayer,
              "user"
            );
          }
        }

        const add = currentLayer && evt.originalEvent.shiftKey;

        const features = self.getFeaturesAtPixel(evt.pixel, {
          hitTolerance: 15,
          layerFilter: layer => !currentLayer || currentLayer === layer
        });

        if(!_.isEmpty(features)) {
          if(currentLayer) {
            if(!add) this.selectedLayer.getSource().clear(true);
            self.$store.commit(
              add ? "addCurrentSelectedFeatures" : "setCurrentSelectedFeatures",
              [
                self.$root.createProxy(
                  features[self.currentEditedLayer].features[0]
                )
              ]
            );
            self.selectedLayer
              .getSource()
              .addFeature(features[self.currentEditedLayer].features[0]);
          } else {
            self.selectedLayer.getSource().clear(true);
            //self.identification = false;
            //self.$root.$emit("identificationFeature", "stop");

            self.show("Identification");
            self.$root.$emit("identificationFeaturesToSelect", features);
          }
        } else {
          self.clearSelectionFeatures();
        }
      });
    },
    configureSelectFeaturesAction() {
      const self = this;

      const dragBox = new DragBox({});
      self.map.addInteraction(dragBox);
      dragBox.setActive(false);

      dragBox.on("boxend", () => {
        if(!self.currentEditedLayer) {
          this.$root.$emit(
            "showSnackbar",
            "error",
            "Brak wybranej aktywnej warstwy"
          );
          return;
        }

        let currentLayer = self.selectLayerByName(self.currentEditedLayer);
        if(!currentLayer) {
          currentLayer = self.selectLayerByName(
            self.currentEditedLayer,
            "user"
          );
        }

        const selectedFeatures = [];
        currentLayer
          .getSource()
          .forEachFeatureIntersectingExtent(
            dragBox.getGeometry().getExtent(),
            feature => {
              selectedFeatures.push(feature);
            }
          );

        dragBox.setActive(false);
        self.$root.$emit("selectFeatures", "stop");

        if(selectedFeatures.length === 0) {
          self.clearSelectionFeatures();
        } else {
          self.selectedLayer.getSource().clear(true);
          self.$store.commit(
            "setCurrentSelectedFeatures",
            _.map(selectedFeatures, f => self.$root.createProxy(f))
          );
          self.selectedLayer.getSource().addFeatures(selectedFeatures);
        }
      });

      return {
        setActive(value) {
          dragBox.setActive(value);
        },
        getActive() {
          return dragBox.getActive();
        },
        delete() {
          self.map.removeInteraction(dragBox);
        }
      };
    },
    clearSelectionFeatures() {
      this.selectedLayer.getSource().clear(true);
      this.$store.commit("setCurrentSelectedFeatures", []);
    },
    //</editor-fold>

    //<editor-fold defaultstate="collapsed" desc="select element">
    /* zanzaczanie pojedyńczego obiektu
     * setActive(true|false, options)
     * options.multi: jeżeli false to czyści poprzednio zaznaczone; default: false
     * options.once: jeżeli true to automatycznie wyłącza się po użyciu; default: true
     * options.selected: jeżeli true to pokazuje zaznaczone elemety; default: true
     * options.nearest: jeżeli true to zwraca co najwyżej jeden najbliższy elemet; default: false
     * options.layers: zaweżenie wyszukiwania warstw po kluczu "full_type"; default: undefined
     * options.layerTypes zawęża wyszukiwanie do warstw o kluczu "layer_type"; default: undefined; options.layers musi być "undefined"
     * options.callback: nazwa funkcji zwrotnej z zaznaczonymi elementami; default: "selectionElementCallback"
     *
     * @returns {default.methods.configureSelectionSingleElementAction.MapAnonym$142|Generator}
     */
    configureSelectionSingleElementAction() {
      const self = this;
      const config = {
        active: false,
        options: {}
      };
      self.map.on("click", evt => {
        if(!config.active) return;

        const multi = _.get(config.options, "multi", false);
        const once = _.get(config.options, "once", true);
        const showSelected = _.get(config.options, "selected", true);
        const nearest = _.get(config.options, "nearest", false);
        const ignoreDivision = _.get(config.options, "ignoreDivision", false);
        const layerTypes = _.get(config.options, "layerTypes", false);

        let layers = false;
        if("layers" in config.options) {
          //tylko w warstwach wodkan
          layers = _.map(config.options.layers, layer =>
            self.selectLayerByName(layer, "data", true)
          );
        } else if("layerTypes" in config.options) {
          layers = _.filter(
            self.map
              .getLayers()
              .item(2)
              .getLayers()
              .getArray(),
            layer => _.includes(config.options.layerTypes, layer.get("layer_type"))
          );
        }

        const featuresLayers = self.getFeaturesAtPixel(evt.pixel, {
          hitTolerance: 15,
          nearest,
          ignoreDivision,
          layerFilter: layer => !layers || _.includes(layers, layer)
        });

        if(!_.isEmpty(featuresLayers)) {
          const features = _(featuresLayers)
            .map((featuresLayer, layerKey) => featuresLayer.features)
            .flatten()
            .value();

          if(showSelected) {
            if(!multi) this.selectedLayer.getSource().clear(true);

            self.$store.commit(
              multi
                ? "addCurrentSelectedFeatures"
                : "setCurrentSelectedFeatures",
              _.map(features, feature => self.$root.createProxy(feature))
            );

            self.selectedLayer.getSource().addFeatures(features);
          }

          self.$root.$emit(
            _.get(config.options, "callback", "selectionElementCallback"),
            featuresLayers
          );
          config.active = !once;
        } else {
          this.$root.$emit(
            "showSnackbar",
            "orange",
            "Nie znaleziono elementu na warstwie"
          );
        }
      });
      return {
        setActive(value, options = {}) {
          config.options = options;
          config.active = value;
          if(value) {
            self.identification = false;
            self.$root.$emit("identificationFeature", "stop");
          }
        },
        getActive() {
          return config.active;
        }
      };
    },
    /* zaznaczanie po prostokącie
     * setActive(true|false, options)
     * options.multi: jeżeli false to czyści poprzednio zaznaczone; default: false
     * options.once: jeżeli true to automatycznie wyłącza się po użyciu; default: true
     * options.selected: jeżeli true to pokazuje zaznaczone elemety; default: true
     * options.layers: zaweżenie wyszukiwania warstw po kluczu "full_type"; default: undefined
     * options.callback: nazwa funkcji zwrotnej z zaznaczonymi elementami; default: "selectionElementCallback"
     *
     * @returns {default.methods.configureSelectionSingleElementAction.MapAnonym$142|Generator}
     */
    configureSelectionExtentElementAction() {
      const self = this;
      const config = {
        options: {}
      };

      const dragBox = new DragBox({});
      self.map.addInteraction(dragBox);
      dragBox.setActive(false);

      dragBox.on("boxend", () => {
        const multi = _.get(config.options, "multi", false);
        const once = _.get(config.options, "once", true);
        const showSelected = _.get(config.options, "selected", true);

        let layers;
        if("layers" in config.options) {
          //tylko w warstwach wodkan
          layers = _.map(config.options.layers, layer =>
            self.selectLayerByName(layer, "data", true)
          );
        } else {
          layers = _.filter(
            self.map
              .getLayers()
              .item(2)
              .getLayers()
              .getArray(),
            layer => _.includes(["water", "sewer"], layer.get("layer_type"))
          );
        }

        const featuresLayers = _(layers)
          .map(layer => {
            const features = [];
            layer
              .getSource()
              .forEachFeatureInExtent(
                dragBox.getGeometry().getExtent(),
                feature => {
                  features.push(feature);
                }
              );
            return {
              key: layer.get("type"),
              layer,
              features
            };
          })
          .keyBy("key")
          .value();

        if(!_.isEmpty(featuresLayers)) {
          const features = _(featuresLayers)
            .map((featuresLayer, layerKey) => featuresLayer.features)
            .flatten()
            .value();

          if(showSelected) {
            if(!multi) this.selectedLayer.getSource().clear(true);

            self.$store.commit(
              multi
                ? "addCurrentSelectedFeatures"
                : "setCurrentSelectedFeatures",
              _.map(features, feature => self.$root.createProxy(feature))
            );

            self.selectedLayer.getSource().addFeatures(features);
          }

          self.$root.$emit(
            _.get(config.options, "callback", "selectionElementCallback"),
            featuresLayers
          );
          dragBox.setActive(!once);
        } else {
          this.$root.$emit(
            "showSnackbar",
            "orange",
            "Nie znaleziono elementu na warstwie"
          );
        }
      });

      return {
        setActive(value, options = {}) {
          config.options = options;
          dragBox.setActive(value);
          if(value) {
            self.identification = false;
            self.$root.$emit("identificationFeature", "stop");
          }
        },
        getActive() {
          return dragBox.getActive();
        }
      };
    },
    /* zaznaczanie geometrią, liniową lub powierzchniową
     * setActive(true|false, options)
     * options.multi: jeżeli false to czyści poprzednio zaznaczone; default: false
     * options.geometryType: przyjmuje "Polygon" lub "LineString
     * options.once: jeżeli true to automatycznie wyłącza się po użyciu; default: true
     * options.selected: jeżeli true to pokazuje zaznaczone elemety; default: true
     * options.layers: zaweżenie wyszukiwania warstw po kluczu "full_type"; default: undefined
     * options.callback: nazwa funkcji zwrotnej z zaznaczonymi elementami; default: "selectionElementCallback"
     *
     * @returns {default.methods.configureSelectionSingleElementAction.MapAnonym$142|Generator}
     */
    configureSelectionGeometryElementAction() {
      const self = this;
      const config = {
        options: {}
      };

      const drawend = (search_geometry, interaction) => {
        const jsts_search_geometry = ol_parser.read(search_geometry);

        const multi = _.get(config.options, "multi", false);
        const once = _.get(config.options, "once", true);
        const showSelected = _.get(config.options, "selected", true);

        let layers;
        if("layers" in config.options) {
          //tylko w warstwach wodkan
          layers = _.map(config.options.layers, layer =>
            self.selectLayerByName(layer, "data", true)
          );
        } else {
          layers = _.filter(
            self.map
              .getLayers()
              .item(2)
              .getLayers()
              .getArray(),
            layer => _.includes(["water", "sewer"], layer.get("layer_type"))
          );
        }

        const featuresLayers = _(layers)
          .map(layer => {
            const features = [];
            layer
              .getSource()
              .forEachFeatureInExtent(
                search_geometry.getExtent(),
                feature => {
                  const jsts_geometry = ol_parser.read(feature.getGeometry());

                  if (jsts_search_geometry.intersects(jsts_geometry)) {
                    features.push(feature);
                  }
                }
              );
            return {
              key: layer.get("type"),
              layer,
              features
            };
          })
          .keyBy("key")
          .value();

        if(!_.isEmpty(featuresLayers)) {
          const features = _(featuresLayers)
            .map((featuresLayer, layerKey) => featuresLayer.features)
            .flatten()
            .value();

          if(showSelected) {
            if(!multi) this.selectedLayer.getSource().clear(true);

            self.$store.commit(
              multi
                ? "addCurrentSelectedFeatures"
                : "setCurrentSelectedFeatures",
              _.map(features, feature => self.$root.createProxy(feature))
            );

            self.selectedLayer.getSource().addFeatures(features);
          }

          self.$root.$emit(
            _.get(config.options, "callback", "selectionElementCallback"),
            featuresLayers
          );
          interaction.setActive(!once);
        } else {
          this.$root.$emit(
            "showSnackbar",
            "orange",
            "Nie znaleziono elementu na warstwie"
          );
        }
      };
      const drawes = {};

      const types = ["Polygon", "LineString"];

      _.each(types, type => {
        const draw = new Draw({
          type
        });
        draw.geometryType = type;
        self.map.addInteraction(draw);
        draw.setActive(false);

        draw.on("drawend", e => drawend(e.feature.getGeometry(), draw));

        drawes[type] = draw;
      });

      return {
        setActive(value, options = {}) {
          _.each(types, type => drawes[type].setActive(false));

          config.options = options;
          let selectType = options.geometryType || types[0];
          if (!(selectType in drawes)) {
            selectType = types[0];
          }
          drawes[selectType].setActive(value);
          if (value) {
            self.identification = false;
            self.$root.$emit("identificationFeature", "stop");
          }
        },
        getActive() {
          return _.some(types, type => drawes[type].getActive());
        }
      };
    },
    //</editor-fold>

    removeObjectAreaGeometry(data) {
      let payload = {
        body: {
          geometry: {
            type: "Polygon",
            coordinates: []
          }
        },
        id: data.id
      };
      let currentVarianceEdited = data;
      currentVarianceEdited.geometry = payload.body.geometry;
      this.$store.dispatch("editVariance", payload).then(success => {
        if(success) {
          this.$store.commit("setCurrentVariance", currentVarianceEdited);
          this.removeObjectArea();
          this.$root.$emit("geometryArea", undefined);
        }
      });
    },
    addGeomLayer(data) {
      console.log(' : data', data);
      if (data.layerName == 'tasks' && this.users.length == 0) {
        this.$store.dispatch('getUsers');
      }
      let geomLayer = this.map
        .getLayers()
        .getArray()
        .find(l => {
          return l.get("name") == data.layerName;
        });
      if (!geomLayer) {
        let tempFeature;
        let geomSource = new VectorSource({});
        this.$store.dispatch(data.actionName).then(r => {
          if (r) {
            for (let el of r[data.layerName]) {
              if (!el.hasOwnProperty('geometry') || el.geometry == null) continue;
              let tempFeature = new Feature({
                geometry: new Polygon(el.geometry.coordinates),
                properties: el,
                id: el.id,
                fillColor: this.mapColors[el.status].fill,
                strokeColor: this.mapColors[el.status].stroke,
                status: el.status,
                taskType: el.task_type
              });
              tempFeature.setStyle(
                new Style({
                  fill: new Fill({
                    color: this.mapColors[el.status].fill
                  }),
                  stroke: new Stroke({
                    color: this.mapColors[el.status].stroke
                  })
                })
              )
              geomSource.addFeature(tempFeature)
            }
            let geomLayer = new VectorLayer({
              source: geomSource,
              name: data.layerName,
              full_type: data.layerName,
              full_name: data.fullName,
              visible: data.layerName == 'tasks' ? false : true
            });

            this.map.addLayer(geomLayer);
          }
        })
      } else if(data.layerName === 'investments') {
        this.changeLayerVisibility({layer: data.layerName, visibility: true})
      }
    },


    addServitudesLayer(data) {
      let geomLayer = this.map
        .getLayers()
        .getArray()
        .find(l => {
          return l.get("name") == data.layerName;
        });
      if (!geomLayer) {
        let tempFeature;
        let geomSource = new VectorSource({});
        this.$store.dispatch(data.actionName, {with_geometry: true}).then(r => {
          if (r) {
            for (let el of r[data.layerName]) {
              if (!el.hasOwnProperty('geometry') || el.geometry == null) continue;
              let tempFeature = new Feature({
                geometry: new Polygon(el.geometry.coordinates),
                properties: el,
                id: el.id,
                fillColor: this.mapColors[el.status].fill,
                strokeColor: this.mapColors[el.status].stroke,
                status: el.status,
                owner: el.owner_type
              });
              tempFeature.setStyle(
                new Style({
                  fill: new Fill({
                    color: this.mapColors[el.status].fill
                  }),
                  stroke: new Stroke({
                    color: this.mapColors[el.status].stroke
                  })
                })
              )
              geomSource.addFeature(tempFeature)
            }
            let geomLayer = new VectorLayer({
              source: geomSource,
              name: data.layerName,
              full_type: data.layerName,
              full_name: data.fullName,
              visible: false
            });

            this.map.addLayer(geomLayer);
          }
        })
      } else {
        this.changeLayerVisibility({layer: data.layerName, visibility: true})
      }
    },
    setServitudesVisibility(data) {
      let layer = this.map
        .getLayers()
        .getArray()
        .find(l => {
          return l.get("name") == 'transmission_easement';
        });
      if (data[0] == '') {
        layer.setVisible(false);
        return;
      }
      if (!layer.getVisible() && data[1]) {
        layer.setVisible(true);
      }
      for(let feature of layer.getSource().getFeatures()) {
        feature.setStyle(
          new Style({
            fill: new Fill({
              color: data[0] == 'status' ? this.mapColors[feature.get("status")].fill : this.mapColors[feature.get("owner")].fill
            }),
            stroke: new Stroke({
              color: data[0] == 'status' ? this.mapColors[feature.get("status")].stroke : this.mapColors[feature.get("owner")].stroke
            })
          })
        )
      }
    },
    setServitudesOpacity(data) {
      let layer = this.map
        .getLayers()
        .getArray()
        .find(l => {
          return l.get("name") == 'transmission_easement';
        });
      for(let feature of layer.getSource().getFeatures()) {
        if (data[1].name == 'status' && data[0].includes(feature.get("status"))) {
          feature.setStyle(new Style({}));
        } else if (data[1].name == 'owner_type' && data[0].includes(feature.get("owner"))) {
          feature.setStyle(new Style({}));
        } else {
          // if (feature.get("owner") != data[1]) continue;
          feature.setStyle(
            new Style({
              fill: new Fill({
                color: data[1].name == 'status' ? this.mapColors[feature.get("status")].fill : this.mapColors[feature.get("owner")].fill
              }),
              stroke: new Stroke({
                color: data[1].name == 'status' ? this.mapColors[feature.get("status")].stroke : this.mapColors[feature.get("owner")].stroke
              })
            })
          )
        }
      }
    },


    changeLayerVisibility(data) {
       let layer = this.map
        .getLayers()
        .getArray()
        .find(l => {
          return l.get("name") == data.layer;
        });
        if (layer) {
          layer.setVisible(data.visibility);
        }
    },
    setInvestmentOpacity(data) {
      let layer = this.map
        .getLayers()
        .getArray()
        .find(l => {
          return l.get("name") == 'investments';
        });

      for(let feature of layer.getSource().getFeatures()) {
        // feature.setStyle(undefined);
        if (data.includes(feature.get("status"))) {
          feature.setStyle(new Style({}));
        } else {
          feature.setStyle(
            new Style({
              fill: new Fill({
                color: this.mapColors[feature.get("status")].fill
              }),
              stroke: new Stroke({
                color: this.mapColors[feature.get("status")].stroke
              })
            })
          )
        }
      }
    },
    setTasksVisibility(data) {
      this.currentVisibleTask = data;
      let layer = this.map
        .getLayers()
        .getArray()
        .find(l => {
          return l.get("name") == 'tasks';
        });
      if (!layer.getVisible() && data[1]) {
        layer.setVisible('true');
      }

      for(let feature of layer.getSource().getFeatures()) {
        // feature.setStyle(undefined);
        if (data[0] != feature.get("taskType")) {
          feature.setStyle(new Style({}));
        } else {
          feature.setStyle(
            new Style({
              fill: new Fill({
                color: this.mapColors[feature.get("status")].fill
              }),
              stroke: new Stroke({
                color: this.mapColors[feature.get("status")].stroke
              })
            })
          )
        }
      }
    },
    setTasksOpacity(data) {
      let layer = this.map
        .getLayers()
        .getArray()
        .find(l => {
          return l.get("name") == 'tasks';
        });

      for(let feature of layer.getSource().getFeatures()) {
        if (data[0].includes(feature.get("status"))) {
          feature.setStyle(new Style({}));
        } else {
          if (feature.get("taskType") != data[1]) continue;
          feature.setStyle(
            new Style({
              fill: new Fill({
                color: this.mapColors[feature.get("status")].fill
              }),
              stroke: new Stroke({
                color: this.mapColors[feature.get("status")].stroke
              })
            })
          )
        }
      }
    },
    setTaskColor(data) {
      let layer = this.map
        .getLayers()
        .getArray()
        .find(l => {
          return l.get("name") == 'tasks';
        });

      if (!layer) return;

      for (let feat of layer.getSource().getFeatures()) {
        if (feat.get("id") == data.id) {
          feat.set("status", data.status);
          feat.setStyle(
            new Style({
              fill: new Fill({
                color: this.mapColors[data.status].fill
              }),
              stroke: new Stroke({
                color: this.mapColors[data.status].stroke
              })
            })
          )
        }
      }
    },
    setInvestmentColor(data) {
      let layer = this.map
        .getLayers()
        .getArray()
        .find(l => {
          return l.get("name") == 'investments';
        });
      if (!layer) return;

      for (let feat of layer.getSource().getFeatures()) {
        if (feat.get("id") == data.id) {
          feat.set("status", data.status);
          feat.setStyle(
            new Style({
              fill: new Fill({
                color: this.mapColors[data.status].fill
              }),
              stroke: new Stroke({
                color: this.mapColors[data.status].stroke
              })
            })
          )
        }
      }
    },
    addObjectArea(data) {
      this.objectAreaGeometry = new VectorLayer({
        source: new VectorSource({
          features: [new GeoJSON().readFeature(data.geometry)]
        })
      });
      let geometryArea = new Polygon(data.geometry.coordinates)
        .getArea()
        .toFixed(2);
      this.$root.$emit("geometryArea", geometryArea);
      this.map.addLayer(this.objectAreaGeometry);
      this.zoomToLayer(this.objectAreaGeometry);
    },
    removeObjectArea() {
      this.map.removeLayer(this.objectAreaGeometry);
      this.objectAreaGeometry = undefined;
    },
    addObjectAreaGeometry(data) {
      this.$root.$emit(
        "showSnackbar",
        "success",
        "Kliknij na mapie, aby narysować obszar"
      );
      this.drawInteraction = new Draw({
        source: new VectorSource(),
        type: "Polygon"
      });
      this.drawInteraction.on("drawend", e => {
        let payload = {
          body: {
            geometry: JSON.parse(new GeoJSON().writeFeature(e.feature)).geometry
          },
          id: data.id
        };
        let currentVarianceEdited = data;
        currentVarianceEdited.geometry = payload.body.geometry;
        this.$root.$emit("computeVarianceArea", [
          currentVarianceEdited.geometry.coordinates
        ]);
        this.$store.dispatch("editVariance", payload).then(success => {
          if(success) {
            this.$root.$emit(
              "showSnackbar",
              "success",
              "Pomyślnie dodano nowy obszar rozbieżności"
            );
            this.$store.commit("setCurrentVariance", currentVarianceEdited);
            this.addObjectArea(currentVarianceEdited);
          } else {
            this.$store.commit("setCurrentVarianceArea", 0);
          }
          this.map.removeInteraction(this.drawInteraction);
          this.drawInteraction = undefined;
        });
      });
      this.map.addInteraction(this.drawInteraction);
    },
    printReport(data) {
      this.$root.$emit("showSnackbar", "#2a579a", "Trwa generowanie raportu");
      // document.getElementById("loader").style.display = "unset";
      let payload = {
        layers: {
          app_layers: [],
          basemap: this.$store.getters.getCurrentBasemap,
          system_layers: []
        },
        oid: data[1]
      };
      if(data[0] == "hydrantCard") {
        delete payload.oid;
        payload.hydrantID = data[1];
        payload.inspectionID = data[2];
      }
      if(data[0] == "inspection") {
        delete payload.oid;
        payload.inspectionID = data[1];
      }
      if(data[0] === "video") {
        payload.net_type = data[2]
      }
      if(data[0] == "task") {
        payload.attachments = data[2]
      }
      // if(data[0] == "task") {
      //   payload.layers.task_layers = [];
      //   Object.keys(data[2]).forEach((key, index) => {
      //     if(key == "pipes_sewers") {
      //       data[2][key].style = this.styles.layers[key][
      //         "Kanalizacja sanitarna"
      //       ];
      //       payload.layers.task_layers.push(data[2][key]);
      //     } else {
      //       data[2][key].style = this.styles.layers[key];
      //       payload.layers.task_layers.push(data[2][key]);
      //     }
      //   });
      // }
      this.map.getLayers().array_[0].values_.layers.array_.forEach(layer => {
        if(layer.values_) {
          if(layer.type === "TILE" && layer.values_.visible === true) {
            if(
              layer.values_.full_type == `${this.geoportalName}:granice_dzialek`
            ) {
              payload.layers.app_layers.push("granice_dzialek");
            } else if(
              layer.values_.full_type == `${this.geoportalName}:punkty_adresowe`
            ) {
              payload.layers.app_layers.push("punkty_adresowe");
            } else if(layer.values_.name != "Brak") {
              if(layer.values_.full_type != null) {
                payload.layers.app_layers.push(layer.values_.full_type);
              }
            }
          }
        }
      });
      this.map.getLayers().array_[2].values_.layers.array_.forEach(layer => {
        if(layer.values_) {
          if(layer.type === "VECTOR" && layer.values_.visible === true) {
            let temp_layer = {
              name: layer.values_.full_type
            };
            if(layer.values_.net_type) {
              temp_layer.style = this.styles.layers[layer.values_.type][
                layer.values_.net_type
              ];
            } else {
              temp_layer.style = this.styles.layers[layer.values_.full_type];
            }

            if(this.labelsShow) {
              let tempNames = []
              for(let el in this.styles.layers) {
                if(this.styles.layers[el].hasOwnProperty('labels')) {
                  tempNames = new Set([...tempNames, ...this.styles.layers[el].labels])
                }
              }
              temp_layer.label_fields = [...tempNames];
            }

            payload.layers.system_layers.push(temp_layer);
            temp_layer = null;
          }
        }
      });
      if(payload.layers.basemap == `${this.geoportalName}:mapa_zasadnicza`) {
        payload.layers.basemap = "mapa zasadnicza";
      } else if(payload.layers.basemap == "Brak") {
        payload.layers.basemap = "";
      }
      this.$store.dispatch(data[0] + "Report", payload).then(success => {
        if(success) {
          this.$root.$emit(
            "showSnackbar",
            "success",
            "Pomyślnie utworzono raport"
          );
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas tworzenia raportu wystąpił błąd"
          );
        }
      });
    },
    printCurrentView(opt_options) {
      const options = _.defaults(opt_options, {
        center: this.map.getView().getCenter(),
        format: 'PNG',
        scale: '1:500',
        size: 'A4',
        template: '_vertical',
        split: false
      });

      this.$root.$emit(
        "showSnackbar",
        "blue",
        "Trwa generowanie wydruku mapy",
        0
      );
      // document.getElementById("loader").style.display = "unset";
      /*const center_2178 = proj4(
        "+proj=tmerc +lat_0=0 +lon_0=19 +k=0.9993 +x_0=500000 +y_0=-5300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.999923 +x_0=7500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
        this.map.getView().getCenter()
      );*/
      const center = transform(options.center, this.$root.projection, this.baseSrid);

      let payload = {
        center_x: center[0],
        center_y: center[1],
        format: options.format.toLowerCase(),
        scale: parseInt(options.scale.slice(2)),
        layers: {
          app_layers: [],
          basemap: this.$store.getters.getCurrentBasemap,
          system_layers: []
        },
        size: options.size,
        template: options.size.toLowerCase() + options.template,
        split: options.split,
        line_geometry: options.line
      };
      const layersArray = this.map.getLayers().getArray();
      layersArray[0].getLayers().forEach(layer => {
        if((layer instanceof TileLayer || layer instanceof VectorTileLayer) && layer.get('type') === 'app_layer' && layer.getVisible()) {
          //TileLayer - WM(T)S, XYZ
          //VectorTileLayer - MVT, u nas granice_dzialek

          // if (layer.values_.name == `${this.geoportalName}:granice_dzialek`) {
          //   payload.layers.app_layers.push("granice_dzialek");
          // } else if (
          //   layer.values_.name == `${this.geoportalName}:punkty_adresowe`
          // ) {
          //   payload.layers.app_layers.push("punkty_adresowe");
          // } else if (
          //   layer.values_.name == `${this.geoportalName}:granice_stref_dma`
          // ) {
          //   payload.layers.app_layers.push("granice_stref_DMA");
          // } else {
          //   payload.layers.app_layers.push(layer.values_.full_type);
          // }
          payload.layers.app_layers.push(layer.get('name').slice(this.geoportalName.length + 1));
        }
      });
      layersArray[2].getLayers().forEach(layer => {
        if(layer instanceof VectorLayer && layer.getVisible()) {
          let tempNames = [];
          let temp_layer = {
            name: layer.get('full_type')
          };
          if(layer.get('net_type')) {
            temp_layer.style = this.styles.layers[layer.get('type')][layer.get('net_type')];
          } else {
            temp_layer.style = this.styles.layers[layer.get('full_type')];
          }

          if(this.labelsShow) {
            temp_layer.label_fields = temp_layer.style.labels;
          }
          payload.layers.system_layers.push(temp_layer);
          temp_layer = null;
        }
      });
      if(payload.layers.basemap === `${this.geoportalName}:mapa_zasadnicza`) {
        payload.layers.basemap = "mapa zasadnicza";
      } else if(payload.layers.basemap === "Brak") {
        payload.layers.basemap = "";
      }
      this.$store.dispatch("printMap", payload).then(success => {
        if(success) {
          this.$root.$emit("hideSnackbar");
          this.$root.$emit(
            "showSnackbar",
            "success",
            "Pomyślnie utworzono wydruk mapy"
          );
          this.$modal.hide("printModal");
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas tworzenia wydruku mapy wystąpił błąd"
          );
        }
      });
    },
    addMapLayer([geom, coordinates], kind) {
      if(this.layer) return;
      this.layer = new VectorLayer({
        source: new VectorSource({
          features: [this.format_GeoJSON.readFeature(geom)]
        })
      });
      if(kind === "folder") {
        let geometryArea = new Polygon(coordinates).getArea().toFixed(2);
        this.$store.commit("setCurrentFolderArea", geometryArea);
      } else if(kind === "variance") {
        let geometryArea = new Polygon(coordinates).getArea().toFixed(2);
        this.$store.commit("setCurrentAddingVariance", true);
        this.$store.commit("setCurrentVarianceArea", geometryArea);
      } else if(kind === "failure") {
        this.$root.$emit("failureGeometry", geom);
      } else if(kind === "refurbishment") {
        this.$root.$emit("refurbishmentGeometry", geom);
      } else if(kind === "profile") {
        this.layer.setStyle(
          // Profil podłużny terenu - czerwona linia
          new Style({
            stroke: new Stroke({
              color: "rgba(255, 0, 0, 0.85)",
              width: 3
            })
          })
        );
        this.$root.$emit("profileLineGeometry", geom);
      }
      this.map.addLayer(this.layer);
    },
    removeMapLayer() {
      this.map.removeLayer(this.layer);
      this.layer = undefined;
    },
    zoomMapLayer() {
      this.zoomToLayer(this.layer);
    },

    //<editor-fold defaultstate="collapsed" desc="FOLDERS">
    folderCardOpened() {
      let geometryArea = new Polygon(this.folderData.geometry.coordinates)
        .getArea()
        .toFixed(2);
      this.$store.commit("setCurrentFolderArea", geometryArea);
    },
    folderCardClosed() {
      if(this.drawInteraction) {
        this.map.removeInteraction(this.drawInteraction);
        this.drawInteraction = undefined;
      }
    },
    addGeometryToMap(data) {
      this.drawInteraction = new Draw({
        source: new VectorSource(),
        type: "Polygon"
      });
      this.drawInteraction.on("drawend", e => {
        let payload = JSON.parse(JSON.stringify(data[0]));
        payload.geometry = JSON.parse(
          new GeoJSON().writeFeature(e.feature)
        ).geometry;
        delete payload.attachments;
        this.$store.dispatch("editFolderData", payload).then(success => {
          if(success) {
            this.$store.commit("setFolderData", payload);
            this.addMapLayer(
              [this.folderData.geometry, this.folderData.geometry.coordinates],
              "folder"
            );
          }
          this.map.removeInteraction(this.drawInteraction);
          this.drawInteraction = undefined;
        });
      });
      this.map.addInteraction(this.drawInteraction);
    },
    /*editionLayers() {
      let ls = [];
      this.map.getLayers().forEach(l => {
        if (["water", "sewer"].indexOf(l.get("layer_type")) < 0) return;
        ls.push({
          name: l.get("full_name"),
          instance: l
        });
      });
      return ls;
    },*/
    //</editor-fold>

    //<editor-fold defaultstate="collapsed" desc="VARIANCES">
    computeVarianceArea(data) {
      let area = new Polygon(data[0]).getArea().toFixed(2);
      this.$store.commit("setCurrentVarianceArea", area);
    },
    addNewVariance() {
      this.drawInteraction = new Draw({
        source: new VectorSource(),
        type: "Polygon"
      });
      this.drawInteraction.on("drawend", e => {
        this.payloadGeom = JSON.parse(
          this.format_GeoJSON.writeFeature(e.feature)
        ).geometry;
        this.addMapLayer(
          [this.payloadGeom, this.payloadGeom.coordinates],
          "variance"
        );
        this.map.removeInteraction(this.drawInteraction);
        this.drawInteraction = undefined;
      });
      this.map.addInteraction(this.drawInteraction);
    },
    addVariance(data) {
      let payload = {
        description: data[0],
        geometry: this.payloadGeom,
        name: data[1],
        status: data[2],
        type: data[3],
        created_at: data[4],
        created_by: data[5]
      };
      this.$store.dispatch("addVariance", payload).then(r => {
        if(!r) {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Błąd przy dodawaniu rozbieżności"
          );
        } else {
          this.$root.$emit("edited_variance");
          this.$root.$emit(
            "showSnackbar",
            "success",
            "Pomyślnie dodano rozbieżności"
          );
        }
      });
    },
    zoomToArea(data) {
      this.zoomToGeometry(new Polygon(data[0]), {duration: 1000});
    },
    zoomToLineString(data) {
      if (data instanceof LineString) {
        this.zoomToGeometry(data, {duration: 1000});
      } else {
        this.zoomToGeometry(new LineString(data[0]), {duration: 1000});
      }
    },
    //</editor-fold>

    streetViewSelection(enabled) {
      // Enable/disable map tool to select a point for StreetView query
      if(this.streetViewInteraction) {
        // First disable existing map tool
        this.map.removeInteraction(this.streetViewInteraction);
        this.streetViewInteraction = undefined;
      }
      if(enabled === false) {
        // Don't go further if command was to disable
        return;
      }

      this.streetViewInteraction = new Draw({
        source: new VectorSource(),
        type: "Point",
        style: new Style({
          image: new Circle({
            fill: new Fill({
              color: "#ffd800"
            }),
            radius: 7,
            stroke: new Stroke({
              color: "#000000",
              width: 1.1
            })
          })
        })
      });
      this.streetViewInteraction.on("drawend", e => {
        let coords = JSON.parse(
          new GeoJSON().writeFeature(e.feature, {
            featureProjection: "EPSG:2180",
            dataProjection: "EPSG:4326"
          })
        ).geometry;

        this.map.removeInteraction(this.streetViewInteraction);
        this.streetViewInteraction = undefined;
        this.$root.$emit("passStreetViewCoords", coords.coordinates);
      });
      this.map.addInteraction(this.streetViewInteraction);
    },

    //<editor-fold defaultstate="collapsed" desc="SCADA">
    drawScadaPoints(data, reset = false) {
      const scadaFeatures = [];
      const source = this.scadaVectorLayer.getSource();

      if(reset) {
        source.clear(true);
      }

      for(let i in data) {
        const element = data[i];
        const feature = new Feature({
          geometry: new Point(element.geometry.coordinates),
          name: element.properties.name,
          symbol: element.properties.code,
          pointID: element.id
        });

        feature.set("pressure", "Brak danych");
        feature.set("flow", "Brak danych");
        feature.set("alarms", "Brak danych");
        feature.setStyle(this.noAlarmInfoStyle);
        for(let measure of element.properties.current_measures) {
          if(measure.unit === "[bar]" || measure.unit === "[MPa]") {
            feature.set(
              "pressure",
              `${measure.value.toFixed(2)} ${measure.unit}`
            );
          } else if(
            measure.unit === "[m3/h]" ||
            measure.unit === "[m3/doba]"
          ) {
            feature.set("flow", `${measure.value.toFixed(2)} ${measure.unit}`);
          } else if(measure.unit === "Nie dotyczy") {
            if(measure.value === 0 || !measure.value) {
              feature.set("alarms", "Brak alarmów");
              feature.setStyle(this.noAlarmStyle);
            } else {
              feature.set("alarms", measure.name);
              feature.setStyle(this.alarmStyle);
            }
          }
        }
        feature.setId(element.id);

        scadaFeatures.push(this.$root.createProxy(feature));
        source.addFeature(feature);
      }

      this.$store.commit("setScadaFeaturesArr", scadaFeatures);
    },
    changeScadaStyle(feature, style) {
      if(style === "noAlarmStyle") {
        feature.setStyle(this.noAlarmStyle);
      } else if(style === "alarmStyle") {
        feature.setStyle(this.alarmStyle);
      } else {
        feature.setStyle(this.noAlarmInfoStyle);
      }
    },
    zoomToAreaReproject(coords, src, dst) {
      this.zoomToGeometry(
        new Polygon([
          coords[0].map(coordinate => {
            return proj4(src, dst, coordinate);
          })
        ]),
        {duration: 1000}
      );
    },
    removeScadaPoint() {
      const source = this.scadaVectorLayer.getSource();
      let featureId = this.currentScadaPoint.id;
      let feature = source.getFeatureById(featureId);
      source.removeFeature(feature);
      this.$store.commit("setScadaFeaturesArr", _.map(source.getFeatures(), (feature) => this.$root.createProxy(feature)));
    },
    addNewScadaPoints(data) {
      const source = this.scadaVectorLayer.getSource();
      const feature = new Feature({
        geometry: new Point(data[1]),
        name: data[0].pointName,
        symbol: data[0].pointCode
      });
      feature.set("pressure", "Brak danych");
      feature.set("flow", "Brak danych");
      feature.set("alarms", "Brak danych");
      feature.setId(data[0].pointID);
      feature.setStyle(this.noAlarmInfoStyle);
      source.addFeature(feature);
      this.$store.commit("setNewScadaFeature", this.$root.createProxy(feature));
    },
    refreshScadaSource(data) {
      const source = this.scadaVectorLayer.getSource();
      if(data) {
        let feature = source.getFeatureById(data.id);
        feature.set("name", data.body.name);
        feature.set("symbol", data.body.code);
        feature.set("description", data.body.description);
      }
      source.refresh();
    },
    clearScadaPoints() {
      const source = this.scadaVectorLayer.getSource();
      source.clear(true);
    },
    //</editor-fold>

    //HydraNet
    drawHydraNetWatermeters(data) {
      const self = this;
      const features = [];
      data = self.$store.getters.getHydraNetWatermeters.features;

      for(let i in data) {
        const element = data[i];
        const feature = new Feature({
          geometry: new Point(element.geometry.coordinates),
          item_alias: element.properties.item_alias,
          address: element.properties.address,
          read_date: element.properties.read_date,
          read_value: element.properties.read_value,
          serial_number: element.properties.serial_number,
          watermeterID: element.id
        });
        feature.setStyle(this.hydranetWatermetersStyle);

        feature.setId(element.id);

        features.push(this.$root.createProxy(feature));
        this.hydranetVectorSource.addFeature(feature);
      }

      this.hydranetVectorLayer.setSource(this.hydranetVectorSource);
      this.hydranetVectorLayer.set("name", "hydranetWatermetersLayer");
      this.map.addLayer(this.hydranetVectorLayer);
      // this.$store.commit("setScadaFeaturesArr", features);
    },

    toggleHydraNet() {
      this.hydranetVectorLayer.setVisible(
        !this.hydranetVectorLayer.getVisible()
      );
    },

    // Servitudes
    toggleServitudesLayer(show = false) {
      const self = this;

      function updateShow() {
        const source = self.servitudesVectorLayer.getSource();
        source.clear();

        let servitudes = self.$store.getters.getServitudes.transmission_easement;

        const features = _.map(servitudes, (servitude) => new GeoJSON().readFeature({
          type: "Feature",
          geometry: servitude.geometry || null,
          properties: {
            owner_type: servitude.owner_type,
            parcel: servitude.parcel,
            status: servitude.status,
          },
          id: servitude.id
        }));
        source.addFeatures(features);

        self.servitudesVectorLayer.setVisible(true);
      }
      function updateHide() {
        const source = self.servitudesVectorLayer.getSource();
        source.clear();


        self.servitudesVectorLayer.setVisible(false);
      }

      if(show) {
        if(!self.$store.getters.getServitudes) {
          self.$root.$emit(
            "showSnackbar",
            "success",
            "Trwa pobieranie służebności"
          );
          self.$store.dispatch("getServitudes", {
            with_geometry: true
          }).then(success => {
            if(success) {
              updateShow();
            }
          });
        } else {
          updateShow();
        }
      } else {
        updateHide();
      }
    },
    setFeaturesServitudeStyle(data, type = '') {
      const source = this.servitudesVectorLayer.getSource();

      if(type === 'clear') {
        for(let feature of source.getFeatures()) {
          feature.setStyle(undefined);
        }
      } else if(type === 'empty') {
        for(let feature of source.getFeatures()) {
          feature.setStyle(
            new Style({
              fill: new Fill({
                color: '#00000000'
              })
            })
          );
        }
      } else {
        for(let feature of source.getFeatures()) {
          if(feature.get(data.category) === data.name) {
            feature.setStyle(
              new Style({
                fill: new Fill({
                  color: data.color
                })
              })
            );
          }
        }
      }
    },

    //<editor-fold defaultstate="collapsed" desc="modelowanie wodociągowe">
    addModelWat(linksFeatures, nodesFeatures) {
      const format = new GeoJSON({
        featureProjection: "EPSG:2180",
        dataProjection: this.$store.getters.getSrid
      });

      const linksSource = this.linksVectorLayer.getSource();
      const nodesSource = this.nodesVectorLayer.getSource();

      linksSource.clear(true);
      linksSource.addFeatures(
        format.readFeatures({
          type: "FeatureCollection",
          features: linksFeatures
        })
      );

      nodesSource.clear(true);
      nodesSource.addFeatures(
        format.readFeatures({
          type: "FeatureCollection",
          features: nodesFeatures
        })
      );

      this.refreshModelWat();
    },
    getStylesModelWat() {
      const self = this;

      const last_model = self.modelWatDisplaySettings.last_model;
      if(!last_model) {
        return {
          links(feature) {
            return false;
          },
          nodes(feature) {
            return false;
          }
        };
      }
      const labels = self.modelWatDisplaySettings.labels;
      const timeStep = self.modelWatTimeStep - 1;
      const links = self.modelWatDisplaySettings.links;
      const nodes = self.modelWatDisplaySettings.nodes;
      const legend = self.modelWatDisplaySettings.legend;

      const defa = {
        links: generateDefModelWod('links', links.attribute, last_model.ranges, legend),
        nodes: generateDefModelWod('nodes', nodes.attribute, last_model.ranges, legend)
      };

      return {
        links(feature) {
          const attribute = links.attribute;
          const zoom = self.map.getView().getZoom();

          let color;
          if(attribute === "null") {
            color = category5Color[0];
          } else {
            color = findColor(
              defa.links.range,
              feature.get(attribute)[timeStep]
            );
          }

          let width = links.width;
          if(links.sizeProportions && attribute !== "null") {
            /*
            //proporcionalność liniowa
            const v = feature.get(attribute)[timeStep];
            width = (widthSizePoint * (v - defa.links.min) / defa.links.width) + minSizePoint;
            if (width < 0) {
              width = 0;
            }*/
            width = findSize(
              defa.links.range,
              feature.get(attribute)[timeStep]
            );
          }

          const def = {
            stroke: new Stroke({
              color,
              width
            })
          };

          if(zoom > 16 && (labels.displayLinksID || labels.displayLinksValues)) {
            let textID = '';
            let textValue = '';

            if(labels.displayLinksID) {
              textID = `${feature.get("link_id")}`;
            }

            if(labels.displayLinksValues && attribute !== "null") {
              let value = feature.get(attribute)[timeStep];
              if(typeof value.toFixed === 'function') {
                value = value.toFixed(2);
              }
              textValue = `${value}`;
            }
            def.text = new Text({
              textAlign: "center",
              textBaseline: "middle",
              font: `Normal 12px Open Sans`,
              text: `${textID}
${textValue}`.trim(),
              fill: new Fill({
                color: "white"
              }),
              stroke: new Stroke({
                color: "black",
                width: 3
              }),
              overflow: false,
              placement: "line"
            });
          }

          return new Style(def);
        },
        nodes(feature) {
          const attribute = nodes.attribute;
          const zoom = self.map.getView().getZoom();

          let color;
          if(attribute === "null") {
            color = category5Color[0];
          } else {
            color = findColor(
              defa.nodes.range,
              feature.get(attribute)[timeStep]
            );
          }

          let radius = nodes.size;
          if(nodes.sizeProportions && attribute !== "null") {
            /*
            //proporcionalność liniowa
            const v = feature.get(attribute)[timeStep];
            radius = (widthSizePoint * (v - defa.nodes.min) / defa.nodes.width) + minSizePoint;
            if (radius < 0) {
              radius = 0;
            }
            */
            radius = findSize(
              defa.nodes.range,
              feature.get(attribute)[timeStep]
            );
          }

          const def = {
            image: new Circle({
              radius,
              fill: new Fill({
                color
              })
            })
          };

          if(zoom > 16 && labels.displayNodesID || labels.displayNodesValues) {
            let textID = '';
            let textValue = '';

            if(labels.displayNodesID) {
              textID = `${feature.get("node_id")}`;
            }

            if(labels.displayNodesValues && attribute !== "null") {
              let value = feature.get(attribute)[timeStep];
              if(typeof value.toFixed === 'function') {
                value = value.toFixed(2);
              }
              textValue = `${value}`;
            }

            def.text = new Text({
              textAlign: "end",
              textBaseline: "middle",
              font: `Normal 12px Open Sans`,
              text: `${textID}
${textValue}`.trim(),
              fill: new Fill({
                color: "white"
              }),
              stroke: new Stroke({
                color: "black",
                width: 3
              }),
              overflow: false,
              placement: "point",
              offsetX: 5,
              offsetY: 5
            });
          }

          return new Style(def);
        }
      };
    },
    refreshModelWat(full = true) {
      if(full) {
        const styles = this.getStylesModelWat();
        this.linksVectorLayer.setStyle(styles.links);
        this.nodesVectorLayer.setStyle(styles.nodes);

        this.nodesVectorLayer.setVisible(
          this.modelWatDisplaySettings.nodes.display
        );
        this.linksVectorLayer.setVisible(
          this.modelWatDisplaySettings.links.display
        );
      } else {
        this.linksVectorLayer.changed();
        this.nodesVectorLayer.changed();
      }
    },
    clearModelWat() {
      const linksSource = this.linksVectorLayer.getSource();
      const nodesSource = this.nodesVectorLayer.getSource();

      linksSource.clear(true);
      nodesSource.clear(true);

      const settings = JSON.parse(JSON.stringify(this.modelWatDisplaySettings));
      delete settings.last_model;
      this.$store.commit("setModelWatDisplaySettings", settings);
    },
    //</editor-fold>

    //<editor-fold defaultstate="collapsed" desc="modelowanie kanalizacyjne">
    addModelKan(pipesGeojson, manholesGeojson) {
      const format = new GeoJSON({
        //featureProjection: "EPSG:2180",
        //dataProjection: "EPSG:2178"
      });

      const pipesSource = this.kanPipesLayer.getSource();
      const manholesSource = this.kanManholesLayer.getSource();

      pipesSource.clear(true);
      pipesSource.addFeatures(
        format.readFeatures(pipesGeojson)
      );

      manholesSource.clear(true);
      manholesSource.addFeatures(
        format.readFeatures(manholesGeojson)
      );

      this.refreshModelKan();
    },
    getStylesModelKan() {
      const self = this;

      if(true) {//usunąć po dostosowaniu
        return {
          pipes(feature) {
            const zoom = self.map.getView().getZoom();

            const def = {
              stroke: new Stroke({
                color: 'red',
                width: 5
              })
            };

            if(zoom > 16) {
              let textValue = '';
              let value = feature.get("volume");
              if(typeof value.toFixed === 'function') {
                value = value.toFixed(2);
              }
              textValue = `${value}`;

              def.text = new Text({
                textAlign: "center",
                textBaseline: "middle",
                font: `Normal 12px Open Sans`,
                text: `${textValue}`.trim(),
                fill: new Fill({
                  color: "white"
                }),
                stroke: new Stroke({
                  color: "black",
                  width: 3
                }),
                overflow: false,
                placement: "line"
              });
            }

            return new Style(def);
          },
          manholes(feature) {
            const zoom = self.map.getView().getZoom();

            const def = {
              image: new Circle({
                radius: 5,
                fill: new Fill({
                  color: 'orange'
                })
              })
            };

            if(zoom > 16) {
              let textValue = '';
              let value = feature.get("volume_acc");
              if(typeof value.toFixed === 'function') {
                value = value.toFixed(2);
              }
              textValue = `${value}`;

              def.text = new Text({
                textAlign: "end",
                textBaseline: "middle",
                font: `Normal 12px Open Sans`,
                text: `${textValue}`.trim(),
                fill: new Fill({
                  color: "white"
                }),
                stroke: new Stroke({
                  color: "black",
                  width: 3
                }),
                overflow: false,
                placement: "point",
                offsetX: 5,
                offsetY: 5
              });
            }

            return new Style(def);
          }
        };
      }

      /*const last_model = self.modelWatDisplaySettings.last_model;
      if (!last_model) {
        return {
          pipes(feature) {
            return false;
          },
          manholes(feature) {
            return false;
          }
        };
      }
      const labels = self.modelWatDisplaySettings.labels;
      const timeStep = self.modelWatTimeStep - 1;
      const links = self.modelWatDisplaySettings.links;
      const nodes = self.modelWatDisplaySettings.nodes;
      const legend = self.modelWatDisplaySettings.legend;

      const defa = {
        links: generateDefModelWod('links', links.attribute, last_model.ranges, legend),
        nodes: generateDefModelWod('nodes', nodes.attribute, last_model.ranges, legend)
      };

      return {
        pipes(feature) {
          const attribute = links.attribute;
          const zoom = self.map.getView().getZoom();

          let color;
          if(attribute === "null") {
            color = category5Color[0];
          } else {
            color = findColor(
              defa.links.range,
              feature.get(attribute)[timeStep]
            );
          }

          let width = links.width;
          if(links.sizeProportions && attribute !== "null") {
            width = findSize(
              defa.links.range,
              feature.get(attribute)[timeStep]
            );
          }

          const def = {
            stroke: new Stroke({
              color,
              width
            })
          };

          if(zoom > 16 && (labels.displayLinksID || labels.displayLinksValues)) {
            let textID = '';
            let textValue = '';

            if(labels.displayLinksID) {
              textID = `${feature.get("link_id")}`;
            }

            if(labels.displayLinksValues && attribute !== "null") {
              let value = feature.get(attribute)[timeStep];
              if(typeof value.toFixed === 'function') {
                value = value.toFixed(2);
              }
              textValue = `${value}`;
            }
            def.text = new Text({
              textAlign: "center",
              textBaseline: "middle",
              font: `Normal 12px Open Sans`,
              text: `${textID}
${textValue}`.trim(),
              fill: new Fill({
                color: "white"
              }),
              stroke: new Stroke({
                color: "black",
                width: 3
              }),
              overflow: false,
              placement: "line"
            });
          }

          return new Style(def);
        },
        manholes(feature) {
          const attribute = nodes.attribute;
          const zoom = self.map.getView().getZoom();

          let color;
          if(attribute === "null") {
            color = category5Color[0];
          } else {
            color = findColor(
              defa.nodes.range,
              feature.get(attribute)[timeStep]
            );
          }

          let radius = nodes.size;
          if(nodes.sizeProportions && attribute !== "null") {
            radius = findSize(
              defa.nodes.range,
              feature.get(attribute)[timeStep]
            );
          }

          const def = {
            image: new Circle({
              radius,
              fill: new Fill({
                color
              })
            })
          };

          if(zoom > 16 && labels.displayNodesID || labels.displayNodesValues) {
            let textID = '';
            let textValue = '';

            if(labels.displayNodesID) {
              textID = `${feature.get("node_id")}`;
            }

            if(labels.displayNodesValues && attribute !== "null") {
              let value = feature.get(attribute)[timeStep];
              if(typeof value.toFixed === 'function') {
                value = value.toFixed(2);
              }
              textValue = `${value}`;
            }

            def.text = new Text({
              textAlign: "end",
              textBaseline: "middle",
              font: `Normal 12px Open Sans`,
              text: `${textID}
${textValue}`.trim(),
              fill: new Fill({
                color: "white"
              }),
              stroke: new Stroke({
                color: "black",
                width: 3
              }),
              overflow: false,
              placement: "point",
              offsetX: 5,
              offsetY: 5
            });
          }

          return new Style(def);
        }
      };*/
    },
    refreshModelKan(full = true) {
      if(full) {
        const styles = this.getStylesModelKan();
        this.kanPipesLayer.setStyle(styles.pipes);
        this.kanManholesLayer.setStyle(styles.manholes);

        this.kanManholesLayer.setVisible(
          true, //this.modelWatDisplaySettings.nodes.display
        );
        this.kanPipesLayer.setVisible(
          true, //this.modelWatDisplaySettings.links.display
        );
      } else {
        this.kanPipesLayer.changed();
        this.kanManholesLayer.changed();
      }
    },
    clearModelKan() {
      const pipesSource = this.kanPipesLayer.getSource();
      const manholesSource = this.kanManholesLayer.getSource();

      pipesSource.clear(true);
      manholesSource.clear(true);

      /*const settings = JSON.parse(JSON.stringify(this.modelWatDisplaySettings));
      delete settings.last_model;
      this.$store.commit("setModelWatDisplaySettings", settings);*/
    },
    //</editor-fold>

    drawVirtualRecipients() {
      let recipientStyle = new Style({
        image: new Circle({
          radius: 10,
          fill: new Fill({color: "#007530"}),
          stroke: new Stroke({
            color: [255, 255, 0],
            width: 2
          })
        })
      });

      const self = this;
      let data = self.$store.getters.getVirtualRecipients.features;
      const features = [];

      for(let i in data) {
        const element = data[i];
        const feature = new Feature({
          geometry: new Point(element.geometry.coordinates),
          address: element.properties.address,
          symbol: element.properties.code,
          recipientID: element.id,
          properties: element.properties
        });
        feature.setStyle(recipientStyle);
        feature.setId(element.id);

        features.push(this.$root.createProxy(feature));
        this.virtualRecipientsSource.addFeature(feature);
      }

      this.virtualRecipientsLayer.setSource(this.virtualRecipientsSource);
      this.virtualRecipientsLayer.set("name", "virtualRecipientsLayer");
      this.map.addLayer(this.virtualRecipientsLayer);
      this.$store.commit("setVirtualRecipients", features);
    },
    addVirtualRecipientPoint(data) {
      let recipientStyle = new Style({
        image: new Circle({
          radius: 10,
          fill: new Fill({color: "#007530"}),
          stroke: new Stroke({
            color: [255, 255, 0],
            width: 2
          })
        })
      });
      let newPoint = new Feature({
        geometry: new Point(data[1]),
        address: data[0].address,
        recipientID: data[0].id,
        properties: {
          address: data[0].address,
          curve_id: data[0].pattern,
          demand: data[0].demand,
          description: data[0].description,
          parent_junction: data[0].parent_junction,
          pattern: data[0].pattern,
          unit: data[0].unit
        }
      });
      newPoint.setStyle(recipientStyle);
      newPoint.setId(data[2]);
      this.virtualRecipientsSource.addFeature(newPoint);
      this.virtualRecipientsSource.refresh();
    },
    removeVirtualRecipientPoint(oid) {
      let featureId = oid;
      let feature = this.virtualRecipientsSource.getFeatureById(featureId);
      this.virtualRecipientsSource.removeFeature(feature);
    },

    //start
    coordSystemChanged(val) {
      if(val == "WGS84") {
        this.mousePositionControl.setProjection("EPSG:4326");
      } else if(val == "1992") {
        this.mousePositionControl.setProjection("EPSG:2180");
      } else {
        this.mousePositionControl.setProjection(this.$store.getters.getSrid);
      }
    },
    // Failures
    failureNetworkReport(data) {
      this.$root.$emit("showSnackbar", "#2a579a", "Trwa generowanie raportu");
      // document.getElementById("loader").style.display = "unset";
      let payload = data;
      payload.layers = {
        basemap: this.$store.getters.getCurrentBasemap,
        system_layers: []
      };
      let availableLayers = [
        "pipes",
        "terminals",
        "hydrants",
        "valves",
        "pipes_sewers",
        "terminals_sewers",
        "hydrants_sewers",
        "valves_sewers"
      ];
      this.map.getLayers().array_[2].values_.layers.array_.forEach(layer => {
        if(layer.values_) {
          if(
            layer.type === "VECTOR" &&
            layer.values_.visible === true &&
            availableLayers.includes(layer.values_.type)
          ) {
            let temp_layer = {
              name: layer.values_.full_type
            };
            if(layer.values_.net_type) {
              temp_layer.style = this.styles.layers[layer.values_.type][
                layer.values_.net_type
              ];
            } else {
              temp_layer.style = this.styles.layers[layer.values_.full_type];
            }

            if(this.labelsShow) {
              let tempNames = []
              for(let el in this.styles.layers) {
                if(this.styles.layers[el].hasOwnProperty('labels')) {
                  tempNames = new Set([...tempNames, ...this.styles.layers[el].labels])
                }
              }
              temp_layer.label_fields = [...tempNames];
            }

            payload.layers.system_layers.push(temp_layer);
            temp_layer = null;
          }
        }
      });
      if(payload.layers.basemap == `${this.geoportalName}:mapa_zasadnicza`) {
        payload.layers.basemap = "mapa zasadnicza";
      } else if(payload.layers.basemap == "Brak") {
        payload.layers.basemap = "";
      }
      this.$store.dispatch("failureNetworkReport", payload).then(r => {
        if(r.status === 200) {
          this.$root.$emit(
            "showSnackbar",
            "success",
            "Pomyślnie utworzono raport"
          );
        } else {
          this.$root.$emit("showSnackbar", "red", `${r}`);
        }
      });
    },
    toggleVideosLayer(data) {
      if(data) {
        this.videoVectorSource = new VectorSource({});
        this.getVideoCards.forEach(feature => {
          let tempFeature = new Feature({
            geometry: new Polygon(feature.geometry.coordinates),
            properties: feature,
            id: feature.id,
            type: "videos"
          });
          this.videoVectorSource.addFeature(tempFeature);
          tempFeature = undefined;
        });
        this.videoVectorLayer.setSource(this.videoVectorSource);
        this.videoVectorLayer.set("name", "videosLayer");
        this.videoVectorLayer.setStyle(this.videoStyle);
        this.videoVectorLayer.setOpacity(0.5);
        this.map.addLayer(this.videoVectorLayer);
        this.videoVectorLayer.setVisible(true);
      }
      else {
        this.map.removeLayer(this.videoVectorLayer);
      }
    },
    removeVideoLayer() {
      this.map.removeLayer(this.videoVectorLayer);
    },
    toggleRefurbishmentsLayer(data) {
      let isRefurbishmentsLoaded = false;
      let layersArr = this.map.getLayers().getArray();
      for(let i in layersArr) {
        if(layersArr[i].values_.name == "refurbishmentsLayer") {
          isRefurbishmentsLoaded = true;
        }
      }
      if(data == true) {
        if(!isRefurbishmentsLoaded) {
          // nie zawiera warstwy
          if(
            this.$store.getters.getRefurbishments &&
            !this.$store.getters.getRefurbishments.refurbishments
          ) {
            this.$root.$emit(
              "showSnackbar",
              "success",
              "Trwa pobieranie remontów"
            );
            this.$store.dispatch("getRefurbishments").then(success => {
              if(success) {
                this.$store.getters.getRefurbishments.repairs.forEach(
                  feature => {
                    let tempFeature = new Feature({
                      geometry: new Polygon(feature.geometry.coordinates),
                      properties: feature,
                      id: feature.id,
                      type: "refurbishments"
                    });
                    this.refurbishmentsVectorSource.addFeature(tempFeature);
                    tempFeature = undefined;
                  }
                );
                this.refurbishmentsVectorLayer.setSource(
                  this.refurbishmentsVectorSource
                );
                this.refurbishmentsVectorLayer.set(
                  "name",
                  "refurbishmentsLayer"
                );
                this.refurbishmentsVectorLayer.setStyle(
                  this.refurbishmentsStyle
                );
                this.refurbishmentsVectorLayer.setOpacity(0.5);
                this.map.addLayer(this.refurbishmentsVectorLayer);
              }
            });
          } else {
            this.$store.getters.getRefurbishments.repairs.forEach(feature => {
              let tempFeature = new Feature({
                geometry: new Polygon(feature.geometry.coordinates),
                properties: feature,
                id: feature.id,
                type: "refurbishments"
              });
              this.refurbishmentsVectorSource.addFeature(tempFeature);
              tempFeature = undefined;
            });
            this.refurbishmentsVectorLayer.setSource(
              this.refurbishmentsVectorSource
            );
            this.refurbishmentsVectorLayer.set("name", "refurbishmentsLayer");
            this.refurbishmentsVectorLayer.setStyle(this.refurbishmentsStyle);
            this.videoVectorLayer.setOpacity(0.5);
            this.map.addLayer(this.refurbishmentsVectorLayer);
          }
        } else {
          // zawiera warstwę czyli tylko visible = true
          this.refurbishmentsVectorLayer.setVisible(true);
        }
      } else {
        // layer set visilbe false
        this.refurbishmentsVectorLayer.setVisible(false);
      }
    },
    toggleVariancesLayer(data) {
      let isVariancesLoaded = false;
      let layersArr = this.map.getLayers().getArray();
      for(let i in layersArr) {
        if(layersArr[i].values_.name == "variancesLayer") {
          isVariancesLoaded = true;
        }
      }
      if(data) {
        if(!isVariancesLoaded) {
          // nie zawiera warstwy
          if(
            this.$store.getters.getVariancesData &&
            !this.$store.getters.getVariancesData.features
          ) {
            this.$root.$emit(
              "showSnackbar",
              "success",
              "Trwa pobieranie rozbieżności"
            );
            this.$store.dispatch("getVariances").then(success => {
              if(success) {
                this.$store.getters.getVariancesData.features.forEach(
                  feature => {
                    let tempFeature = new Feature({
                      geometry: new Polygon(feature.geometry.coordinates),
                      properties: feature,
                      id: feature.id,
                      type: "variances"
                    });
                    this.variancesVectorSource.addFeature(tempFeature);
                    tempFeature = undefined;
                  }
                );
                this.variancesVectorLayer.setSource(this.variancesVectorSource);
                this.variancesVectorLayer.set("name", "variancesLayer");
                this.variancesVectorLayer.setStyle(this.variancesStyle);
                this.variancesVectorLayer.setOpacity(0.8);
                this.map.addLayer(this.variancesVectorLayer);
              }
            });
          } else {
            this.$store.getters.getVariancesData.features.forEach(feature => {
              let tempFeature = new Feature({
                geometry: new Polygon(feature.geometry.coordinates),
                properties: feature,
                id: feature.id,
                type: "variances"
              });
              this.variancesVectorSource.addFeature(tempFeature);
              tempFeature = undefined;
            });
            this.servitudesVectorLayer.setSource(this.variancesVectorSource);
            this.variancesVectorLayer.set("name", "variancesLayer");
            this.variancesVectorLayer.setStyle(this.variancesStyle);
            this.videoVectorLayer.setOpacity(0.8);
            this.map.addLayer(this.variancesVectorLayer);
          }
        } else {
          // zawiera warstwę czyli tylko visible = true
          this.variancesVectorLayer.setVisible(true);
        }
      } else {
        // layer set visilbe false
        this.variancesVectorLayer.setVisible(false);
      }
    },
    addNewArea(data) {
      if(this.drawInteraction) {
        return;
      }
      this.drawInteraction = new Draw({
        source: new VectorSource(),
        type: "Polygon"
      });
      this.drawInteraction.on("drawend", e => {
        this.payloadGeom = JSON.parse(
          new GeoJSON().writeFeature(e.feature)
        ).geometry;
        let payloadGeom4326 = JSON.parse(
          new GeoJSON().writeFeature(e.feature, {
            featureProjection: "EPSG:2180",
            dataProjection: "EPSG:4326"
          })
        ).geometry;
        this.addMapLayer(
          [this.payloadGeom, this.payloadGeom.coordinates],
          data
        );
        this.map.removeInteraction(this.drawInteraction);
        this.drawInteraction = undefined;
        this.$root.$emit('newGeomAdded', [this.payloadGeom, payloadGeom4326, data]);
      });
      this.map.addInteraction(this.drawInteraction);
    },
    transformPolygon(poly) {
      let feature = new Feature({
        geometry: new Polygon(poly.coordinates)
      })
      let test = JSON.parse(
        new GeoJSON().writeFeature(feature, {
          featureProjection: "EPSG:2180",
          dataProjection: "EPSG:4326"
        })
      ).geometry;
      this.$root.$emit('newpolygonGeom', [test]);
    },

    installEPSG() {
      proj4.defs(
        "EPSG:2176",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.999923 +x_0=5500000 +y_0=0 +ellps=GRS80 +units=m +no_defs"
      );
      proj4.defs(
        "EPSG:2177",
        "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.999923 +x_0=6500000 +y_0=0 +ellps=GRS80 +units=m +no_defs"
      );
      proj4.defs(
        "EPSG:2178",
        "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.999923 +x_0=7500000 +y_0=0 +ellps=GRS80 +units=m +no_defs"
      );
      proj4.defs(
        "EPSG:2179",
        "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.999923 +x_0=8500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs"
      );
      proj4.defs(
        "EPSG:2180",
        "+proj=tmerc +lat_0=0 +lon_0=19 +k=0.9993 +x_0=500000 +y_0=-5300000 +ellps=GRS80 +units=m +no_defs +axis=enu"
      );
      register(proj4);
    },
    loadToMap(type) {
      switch(type) {
        case "sketche":
          this.getSketches();
          break;
        case "user":
          this.getUserLayers();
          break;
        case "wms":
          this.getWMSLayers();
          break;
      }
    },

    deleteAllCookies() {
      const cookies = document.cookie.split(";");

      _.each(cookies, cookie => {
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
      });
    },
    chackLastChangeSource(force = false) {
      const self = this;

      function execut(r) {
        const token = localStorage.accesstoken || "";
        const username = localStorage.username || "";

        localStorage.clear();
        sessionStorage.clear();
        self.deleteAllCookies();
        if("caches" in window) caches.delete("aquagis");

        sessionStorage["auto-clear-reload"] = JSON.stringify(true);
        localStorage.accesstoken = token;
        localStorage.username = username;
        localStorage.last_change_source = r;

        location.reload(true);
      }

      self.$store.dispatch("getLastUpdateSource").then(r => {
        if(r) {
          r = r.replace(" +", "+");
          console.log(`Data aktualizacji: ${r}`);
          let old = localStorage.last_change_source;

          if(force || (old && old !== r)) {
            old = old.replace(" +", "+");
            self.$modal.show("dialog", {
              title: "Stara wersja strony",
              text: `Czy chcesz wymusić czyszczenie danych lokalnych?<br/>Aktualna: ${new Date(
                old
              ).toLocaleString()}<br/>Nowa: ${new Date(r).toLocaleString()}`,
              buttons: [
                {
                  title: "NIE",
                  handler: () => {
                    self.$modal.hide("dialog");
                    localStorage.last_change_source = r;
                  }
                },
                {
                  title: "TAK",
                  default: true,
                  handler: () => {
                    self.$modal.hide("dialog");
                    execut(r);
                  }
                }
              ]
            });
          } else if(!old) {
            localStorage.last_change_source = r;
          }
        }
      });
    },
    chackStatusSubService(modal = false) {
      const self = this;

      const values = {
        "connected": "Połączenie prawidłowe.",
        "connection problems": "Dostęp do docelowej bazy został utracony. Skontaktuj się z administratorem",
        "not connected": "Połączenie nie zostało zestawione podczas uruchamiania aplikacji. Skontaktuj się z administratorem"
      };

      const keys = {
        "gwmax": "GW-Max",
        "scada": "SCADA"
      };

      if(modal) {
        self.$root.$emit("dialogWidth", 600);
      }

      self.$store.dispatch("getStatusSubService").then(r => {
        if(r) {
          let message = 'Połączenie z: <br/>';
          const now = new Date().toLocaleString();

          _.each(r, (v, k) => {
            let tk = _.get(keys, k, k);
            let tv = _.get(values, v, v);

            message += `- '${tk}' ma stan: ${tv}<br/>`;
            if(!modal) {
              console.log(`Połączenie z '${tk}' ma stan [${now}]: '${v}' - ${tv}`);
            }
          });

          if(modal) {
            self.$modal.show("dialog", {
              title: `Stan baz danych podpiętych do systemu na: ${now}`,
              text: message,
              buttons: [
                {
                  title: "OK",
                  default: true,
                  handler: () => {
                    self.$modal.hide("dialog");
                    self.$root.$emit("dialogWidth");
                  }
                }
              ]
            });
          }
        }
      });
    },
    addNewView(viewName) {
      let activeLayers = {
        data: [],
        additional: [],
        wms: [],
        user: [],
        sketche: []
      };

      let inactiveLayers = {
        data: [],
        additional: [],
        wms: [],
        user: [],
        sketche: []
      };

      for(let layName in this.visibleLayers) {
        if(this.visibleLayers[layName]) {
          if(layName.startsWith("user_layer_")) {
            activeLayers.user.push(layName);
          } else if(layName.startsWith("app_layer_")) {
            activeLayers.additional.push(layName);
          } else if(layName.startsWith("sketche_layer_")) {
            activeLayers.sketche.push(layName);
          } else if(layName.startsWith("wms_layer_")) {
            activeLayers.wms.push(layName);
          } else if(layName.startsWith("temp_layer_")) {
          } else {
            activeLayers.data.push(layName);
          }
        }
      }

      for(let layName in this.visibleLayers) {
        if(!this.visibleLayers[layName]) {
          if(layName.startsWith("user_layer_")) {
            inactiveLayers.user.push(layName);
          } else if(layName.startsWith("app_layer_")) {
            inactiveLayers.additional.push(layName);
          } else if(layName.startsWith("sketche_layer_")) {
            inactiveLayers.sketche.push(layName);
          } else if(layName.startsWith("wms_layer_")) {
            inactiveLayers.wms.push(layName);
          } else if(layName.startsWith("temp_layer_")) {
          } else {
            inactiveLayers.data.push(layName);
          }
        }
      }

      let payload = {
        data: {
          basemap: this.currentBasemap,
          center: this.map.getView().getCenter(),
          zoom: this.map.getView().getZoom(),
          activeLayers,
          inactiveLayers
        },
        name: viewName
      };

      this.$store.dispatch("addView", payload).then(r => {
        if(r.status == 200) {
          this.$root.$emit(
            "showSnackbar",
            "success",
            "Poprawnie zapisano widok"
          );
          this.$root.$emit("loadViews");
        } else {
          this.$root.$emit("showSnackbar", "red", `${r}`);
        }
      });
    },
    loadNewView(view) {
      this.map.getView().setCenter(view.data.center);
      this.map.getView().setZoom(view.data.zoom);
      this.switchBasemapByName(view.data.basemap);
      this.$store.commit("setCurrentBasemap", view.data.basemap);

      let activeLayers = view.data.activeLayers;
      let inactiveLayers = view.data.inactiveLayers;

      for(let layer in activeLayers) {
        if(activeLayers[layer].length > 0) {
          for(let el of activeLayers[layer]) {
            this.toggleLayer(el, true, layer);
          }
        }
      }
      for(let layer in inactiveLayers) {
        if(inactiveLayers[layer].length > 0) {
          for(let el of inactiveLayers[layer]) {
            this.toggleLayer(el, false, layer);
          }
        }
      }
    },
    setBasemapOpacity(sliderValue) {
      this.map.getLayers().forEach(layer => {
        if(layer instanceof LayerGroup) {
          layer.getLayers().forEach(function (groupLayer) {
            if(layer.values_.name == "warstwy podkładowe" && groupLayer instanceof TileLayer) {
              groupLayer.setOpacity(sliderValue / 100);
            }
          });
        }
      })
    }
  },
  created() {
    const self = this;
    self.installEPSG();

    //wszystko co OL5
    self.streetViewInteraction = undefined;
    self.drawInteraction = undefined;
    self.layer = undefined;
    self.currentMeasurement = undefined;
    self.objectAreaGeometry = undefined;
    self.snapMeasureFeatures = new Collection();

    self.format_GeoJSON = new GeoJSON();

    self.$store.dispatch("getSrid").then(success => {
      if(!success) {
        self.$store.commit("setSrid", "EPSG:2180");
      }
    });

    //nie dawać styli/source/layer/control bezpośrednio do data!!!
    //w szczegołności layer/source/control bo pośrednio zkładacie obserwera na "mapę"
    //jak coś to this.$root.createProxy(layer) i potem .__value
    self.style = new Style({
      fill: new Fill({
        color: "rgba(255, 255, 255, 0.2)"
      }),
      stroke: new Stroke({
        color: "#ffcc33",
        width: 2
      })
    });
    self.drawStyle = new Style({
      fill: new Fill({
        color: "rgba(255, 255, 255, 0.2)"
      }),
      stroke: new Stroke({
        color: "rgba(0, 0, 0, 0.5)",
        lineDash: [10, 10],
        width: 2
      })
    });

    self.hydranetWatermetersStyle = new Style({
      image: new RegularShape({
        radius: 7,
        fill: new Fill({
          color: "rgba(0, 0, 255, 1)"
        }),
        stroke: new Stroke({
          color: "rgba(255, 255, 255, 1)",
          width: 2
        }),
        points: 4
      })
    });
    self.noAlarmInfoStyle = new Style({
      image: new Circle({
        radius: 10,
        fill: new Fill({color: "#2a579a"}),
        stroke: new Stroke({
          color: [255, 255, 0],
          width: 2
        })
      })
    });
    self.noAlarmInfoStyle = new Style({
      image: new Circle({
        radius: 10,
        fill: new Fill({color: "#2a579a"}),
        stroke: new Stroke({
          color: [255, 255, 0],
          width: 2
        })
      })
    });
    self.noAlarmStyle = new Style({
      image: new Circle({
        radius: 10,
        fill: new Fill({color: "#2a579a"}),
        stroke: new Stroke({
          color: [0, 255, 0],
          width: 2
        })
      })
    });
    self.alarmStyle = new Style({
      image: new Circle({
        radius: 10,
        fill: new Fill({color: "#2a579a"}),
        stroke: new Stroke({
          color: [255, 0, 0],
          width: 2
        })
      })
    });
    self.hydranetVectorSource = new VectorSource({});
    self.hydranetVectorLayer = new VectorLayer({});

    //scada
    self.scadaVectorLayer = new VectorLayer({
      source: new VectorSource(),
      name: "scadaPointsLayer"
    });

    //wodociągowe
    self.linksVectorLayer = new VectorLayer({
      source: new VectorSource(),
      full_type: "model-wat-links", //jeżeli chcemy aby wykrywało w identyfikacji
      name: "Model Wodociągowy odcinki",
      full_name: "Model Wodociągowy - odcinki"
    });
    self.nodesVectorLayer = new VectorLayer({
      source: new VectorSource(),
      full_type: "model-wat-nodes", //jeżeli chcemy aby wykrywało w identyfikacji
      name: "Model Wodociągowy punkty",
      full_name: "Model Wodociągowy - punkty"
    });

    //kanalizacyjne
    self.kanPipesLayer = new VectorLayer({
      source: new VectorSource(),
      full_type: "model-kan-pipes", //jeżeli chcemy aby wykrywało w identyfikacji
      name: "Model Kanalizacyjny rury",
      full_name: "Model Kanalizacyjny - rury"
    });
    self.kanManholesLayer = new VectorLayer({
      source: new VectorSource(),
      full_type: "model-kan-manholes", //jeżeli chcemy aby wykrywało w identyfikacji
      name: "Model Kanalizacyjny studzienki",
      full_name: "Model Kanalizacyjny - studzienki"
    });

    self.servitudesStyle = new Style({
      fill: new Stroke({color: "blue"})
    });
    self.servitudesStyleOpacity0 = new Style({
      fill: new Stroke({color: "rgba(0, 255, 255, 0)"})
    });
    self.servitudesVectorLayer = new VectorLayer({
      source: new VectorSource(),
      style: self.servitudesStyle,
      visible: false,
      full_type: "servitudes", //jeżeli chcemy aby wykrywało w identyfikacji
      name: "Służebność",
      full_name: "Służebność"
    });

    self.virtualRecipientsSource = new VectorSource({});
    self.virtualRecipientsLayer = new VectorLayer({});

    self.mousePositionControl = new MousePosition({
      coordinateFormat: createStringXY(6),
      projection: "EPSG:2180",
      undefinedHTML: "&nbsp;"
    });
    // video
    self.videoVectorSource = new VectorSource({});
    self.videoVectorLayer = new VectorLayer({});
    self.videoStyle = new Style({
      fill: new Stroke({color: "rgb(255,255,0)"})
    });
    // refurbishments
    self.refurbishmentsVectorSource = new VectorSource({});
    self.refurbishmentsVectorLayer = new VectorLayer({});
    self.refurbishmentsStyle = new Style({
      fill: new Stroke({color: "blue"})
    });

    // variances
    self.variancesVectorSource = new VectorSource({});
    self.variancesVectorLayer = new VectorLayer({});
    self.variancesStyle = new Style({
      fill: new Stroke({color: "rgb(255,255,0)"})
    });

    //console.log(this, self.map);
  },
  mounted() {
    const self = this;

    self.$root.$on("setBookmark", self.setBookmark);
    self.measureLayer = new VectorLayer({
      // Empty layer for measurements
      name: "measure",
      zIndex: 100,
      source: new VectorSource()
    });

    let coordSystem;
    if(this.currentCoordSystem === "1992") {
      coordSystem = "EPSG:2180";
    } else if(this.currentCoordSystem === "WGS84") {
      coordSystem = "EPSG:4326";
    } else {
      coordSystem = this.$store.getters.getSrid;
    }
    this.mousePositionControl.setProjection(coordSystem);

    // default zoom, center and rotation
    let zoom = self.$store.getters.getMapCenter[2];
    let center = self.$store.getters.getMapCenter.slice(0, 2);

    if(window.location.hash !== "") {
      // try to restore center, zoom-level and rotation from the URL
      let hash = window.location.hash.replace("#map=", "");
      let parts = hash.split("/");
      if(parts.length === 3) {
        zoom = parseInt(parts[0], 10);
        center = [parseFloat(parts[1]), parseFloat(parts[2])];
      }
    }

    self.map = new Map({
      controls: defaultControls().extend([self.mousePositionControl]),
      target: "map",
      layers: [
        new LayerGroup({
          name: "warstwy podkładowe",
          layers: []
        }),
        new LayerGroup({
          name: "warstwy różne",
          layers: [
            new LayerGroup({
              name: "warstwy użytkownika",
              layers: []
            }),
            new LayerGroup({
              name: "warstwy tymczasowe",
              layers: []
            }),
            new LayerGroup({
              name: "warstwy szkice",
              layers: []
            })
          ]
        }),
        new LayerGroup({
          name: "warstwy danych",
          layers: []
        }),
        new LayerGroup({
          name: "warstwy edycyjne",
          layers: [
            new VectorLayer({
              name: "selected",
              source: new VectorSource(),
              style(feature) {
                if(self.currentEditedLayer) {
                  const styleObject = self.currentEditedLayerStyle;
                  let styles = [
                    ...self.getSelectedStyle(),
                    ...(typeof styleObject === "function"
                      ? styleObject(feature)
                      : styleObject)
                  ];
                  return styles;
                } else {
                  return self.getSelectedStyle();
                }
              }
            }),
            new VectorLayer({
              name: "allows select",
              source: new VectorSource(),
              style(feature) {
                const styleObject = self.currentEditedLayerStyle;
                let styles = [
                  ...self.getAllowSelectStyle(),
                  ...(typeof styleObject === "function"
                    ? styleObject(feature)
                    : styleObject)
                ];
                return styles;
              }
            }),
            new VectorLayer({
              name: "modification",
              source: new VectorSource(),
              style(feature) {
                if(feature.get("__hide") || false) {
                  return;
                }

                const styleObject = self.currentEditedLayerStyle;
                let styles = [
                  ...self.getModyficationStyle(),
                  ...(typeof styleObject === "function"
                    ? styleObject(feature)
                    : styleObject)
                ];
                if(self.getZoom() >= 19) {
                  //kwadraty na połączeniach
                  const s = self.getEditStyleSquartes(feature, [255, 0, 0]);
                  s && styles.push(s);
                }
                return styles;
              }
            })
          ]
        }),
        new LayerGroup({
          name: "warstwy modelowania / aktywne",
          layers: [
            self.linksVectorLayer,
            self.nodesVectorLayer,
            self.kanPipesLayer,
            self.kanManholesLayer,

            self.servitudesVectorLayer,
            self.scadaVectorLayer
          ]
        }),
        self.measureLayer
      ],
      view: new View({
        projection: self.$root.projection,
        center: center,
        zoom: zoom
      }),
      interactions: defaultInteractions({
        doubleClickZoom: false
      })
    });
    self.createNumericScale();
    document.querySelector(".ol-zoom-in").setAttribute("title", "Powiększ");
    document.querySelector(".ol-zoom-out").setAttribute("title", "Pomniejsz");
    self.map.addControl(new ScaleLine());
    self.createMeasureInteraction();
    self.createSnapMeasure();

    var shouldUpdate = true;
    const view = self.map.getView();
    var updatePermalink = function () {
      self.$store.commit("setCurrentZoom", view.getZoom());

      if(!shouldUpdate) {
        // do not update the URL when the view was changed in the 'popstate' handler
        shouldUpdate = true;
        return;
      }

      var center = view.getCenter();
      var hash =
        "#map=" +
        view.getZoom() +
        "/" +
        Math.round(center[0] * 100) / 100 +
        "/" +
        Math.round(center[1] * 100) / 100;
      var state = {
        zoom: view.getZoom(),
        center: view.getCenter()
      };
      window.history.pushState(state, "map", hash);
    };

    self.map.on("moveend", updatePermalink);
    self.map.on("moveend", self.createNumericScale);

    // restore the view state when navigating through the history
    window.addEventListener("popstate", function (event) {
      if(event.state === null) {
        return;
      }
      self.map.getView().setCenter(event.state.center);
      self.map.getView().setZoom(event.state.zoom);
      shouldUpdate = false;
    });

    //<editor-fold defaultstate="collapsed" desc="identyfikacja i zaznaczanie masowe">
    self.configureIdentificationAction();
    const selectFeaturesAction = self.configureSelectFeaturesAction();
    const selectiondFeatureAction = {
      single: self.configureSelectionSingleElementAction(),
      extent: self.configureSelectionExtentElementAction(),
      geometry: self.configureSelectionGeometryElementAction()
    };

    // wywołanie trybu identyfikacji obiektu, spod przyciksu
    // w celu zaznaczani uzywać "enableSelectionElement"
    self.$root.$on("identificationFeature", type => {
      if(type === "start") {
        self.identification = true;
      } else if(type === "cancel") {
        self.identification = false;
      }
    });
    // wywołanie trybu zaznaczania obiektu, spod przyciksu
    // w celu zaznaczani uzywać "enableSelectionElement"
    self.$root.$on("selectFeatures", type => {
      if(type === "start") {
        selectFeaturesAction.setActive(true);
      } else if(type === "cancel") {
        selectFeaturesAction.setActive(false);
      }
    });

    /* włączenie narzędzia do zaznaczania objktów na warstwach
     * options.extent: wybór narzędzia do zaznaczania; default: false
     * options.geometry: wybór narzędzia do zaznaczania geometrią; default: false
     * options.geometryType: jeżeli geometry jest true to przyjmuje "Polygon" lub "LineString
     * options.multi: jeżeli false to czyści poprzednio zaznaczone; default: false
     * options.once: jeżeli true to automatycznie wyłącza się po użyciu; default: true
     * options.selected: jeżeli true to pokazuje zaznaczone elemety; default: true; tylko dla 'options.extent = false'
     * options.nearest: jeżeli true to zwraca co najwyżej jeden najbliższy elemet; default: false
     * options.layers: zaweżenie wyszukiwania warstw po kluczu "full_type"; default: undefined
     * options.callback: nazwa funkcji zwrotnej z zaznaczonymi elementami; default: "selectionElementCallback"
     */
    self.$root.$on("enableSelectionElement", options => {
      if (_.get(options, "geometry", false)) {
        selectiondFeatureAction.geometry.setActive(true, options);
      } else {
        selectiondFeatureAction[
          _.get(options, "extent", false) ? "extent" : "single"
        ].setActive(true, options);
      }
    });
    // wyłączenie narzędzia do zaznaczania objktów na warstwach
    self.$root.$on("disableSelectionElement", () => {
      selectiondFeatureAction.single.setActive(false);
      selectiondFeatureAction.extent.setActive(false);
      selectiondFeatureAction.geometry.setActive(false);
    });
    // czyszczenie zaznaczonych elementów
    self.$root.$on("clearSelectionFeatures", self.clearSelectionFeatures);
    //</editor-fold>

    self.map.on("moveend", e => {
      let position = self.map
        .getView()
        .getCenter()
        .slice();
      position.push(self.map.getView().getZoom());
      self.$store.commit("setMapCenter", position);
    });

    self.$root.$on("toggleLayer", self.toggleLayer);
    self.$root.$on("switchBasemapByName", self.switchBasemapByName);
    self.$root.$on("setPosition", self.setPosition);
    self.$root.$on("addMeasure", () => {
      self.measuring = true;
    });
    self.$root.$on("removeMeasure", () => {
      self.measuring = false;
    });
    self.$root.$on("removeDrawingInteraction", this.removeDrawingInteraction);
    self.$root.$on("addGeomLayer", self.addGeomLayer);
    self.$root.$on("addServitudesLayer", self.addServitudesLayer);
    self.$root.$on("changeLayerVisibility", self.changeLayerVisibility);
    self.$root.$on("setInvestmentOpacity", self.setInvestmentOpacity);
    self.$root.$on("setTaskColor", self.setTaskColor);
    self.$root.$on("setInvestmentColor", self.setInvestmentColor);
    self.$root.$on("setTasksOpacity", self.setTasksOpacity);
    self.$root.$on("setTasksVisibility", self.setTasksVisibility);
    self.$root.$on("setServitudesVisibility", self.setServitudesVisibility);
    self.$root.$on("setServitudesOpacity", self.setServitudesOpacity);
    self.$root.$on("addObjectArea", self.addObjectArea);
    self.$root.$on("addObjectAreaGeometry", self.addObjectAreaGeometry);
    self.$root.$on("removeObjectArea", self.removeObjectArea);
    self.$root.$on("removeObjectAreaGeometry", self.removeObjectAreaGeometry);
    self.$root.$on("printCurrentView", self.printCurrentView);
    self.$root.$on("removeMapLayer", self.removeMapLayer);
    self.$root.$on("addMapLayer", self.addMapLayer);
    self.$root.$on("zoomMapLayer", self.zoomMapLayer);
    self.$root.$on("addGeometryToMap", self.addGeometryToMap);
    self.$root.$on("folderCardOpened", self.folderCardOpened);
    self.$root.$on("folderCardClosed", self.folderCardClosed);
    //self.$root.$on("editionLayers", self.editionLayers);
    self.$root.$on("removeMarker", self.removeMarker);
    self.$root.$on("addTempLayer", self.addTempLayer);
    self.$root.$on("addUserLayer", layer => self.addUserLayer(layer, true));
    self.$root.$on("updateUserLayer", self.updateUserLayer);
    self.$root.$on("addRasterLayer", self.addRasterLayer);
    self.$root.$on("updateLayerFields", self.updateLayerFields);

    self.$root.$on("addNewView", self.addNewView);
    self.$root.$on("loadNewView", self.loadNewView);

    self.$root.$on("highlightFeature", self.highlightFeature);

    //VIDEO
    self.$root.$on("drawVideoInspections", self.toggleVideosLayer);
    self.$root.$on("removeVideoLayer", self.removeVideoLayer);

    // START
    self.$root.$on("coordSystemChanged", self.coordSystemChanged);

    // Analysis
    self.$root.$on("addMarker", self.addMarker);
    self.$root.$on("showCutoff", self.showCutoff);
    self.$root.$on("clearCutoff", self.clearCutoff);
    self.$root.$on("addNewLine", self.addNewLine);
    self.$root.$on("zoomToLineString", self.zoomToLineString);

    // SCADA
    self.$root.$on("drawScadaPoints", self.drawScadaPoints);
    self.$root.$on("addNewScadaPoints", self.addNewScadaPoints);
    self.$root.$on("refreshScadaSource", self.refreshScadaSource);
    self.$root.$on("changeScadaStyle", self.changeScadaStyle);
    self.$root.$on("removeScadaPoint", self.removeScadaPoint);
    self.$root.$on("clearScadaPoints", self.clearScadaPoints);

    // Servitudes
    self.$root.$on("toggleServitudesLayer", self.toggleServitudesLayer);
    self.$root.$on("setFeaturesServitudeStyle", self.setFeaturesServitudeStyle);

    // refurbishments
    self.$root.$on("drawRefurbishments", self.toggleRefurbishmentsLayer);

    // Variances
    self.$root.$on("computeVarianceArea", self.computeVarianceArea);
    self.$root.$on("addNewVariance", self.addNewVariance);
    self.$root.$on("addVariance", self.addVariance);
    self.$root.$on("zoomToArea", self.zoomToArea);
    self.$root.$on("zoomToAreaReproject", self.zoomToAreaReproject);
    self.$root.$on("drawVariances", self.toggleVariancesLayer);

    // Failures
    self.$root.$on("addNewArea", self.addNewArea);
    self.$root.$on("failureNetworkReport", self.failureNetworkReport);

    self.$root.$on('transformPolygon', self.transformPolygon)

    // Reports
    self.$root.$on("printReport", self.printReport);

    // HydraNet

    self.$root.$on("drawHydraNetWatermeters", self.drawHydraNetWatermeters);
    self.$root.$on("toggleHydraNet", self.toggleHydraNet);

    // modelowanie wod
    self.$root.$on("drawVirtualRecipients", self.drawVirtualRecipients);
    self.$root.$on("addVirtualRecipientPoint", self.addVirtualRecipientPoint);
    self.$root.$on(
      "removeVirtualRecipientPoint",
      self.removeVirtualRecipientPoint
    );
    self.$root.$on("addModelWat", self.addModelWat);
    self.$root.$on("clearModelWat", self.clearModelWat);

    // modelowanie kan
    self.$root.$on("addModelKan", self.addModelKan);
    self.$root.$on("clearModelKan", self.clearModelKan);

    // StreetView
    self.$root.$on("enableStreetViewSelection", self.streetViewSelection);

    self.$root.$on("setBasemapOpacity", self.setBasemapOpacity);

    self.getBaselayers();
    self.getStyles();
    //dodane w proxy, mozna uzywac jako zywklej klasy map lub wyciagnac argument *_value*
    self.$store.commit("bindMap", self.$root.createProxy(self.map));
    self.$root.$on("zoomToGeometry", self.zoomToGeometry);
    self.$root.$on("zoomToFeature", self.zoomToFeature);
    self.$root.$on("zoomToExtent", self.zoomToExtent);
    self.$root.$on("zoomToBBox", self.zoomToBBox);
    self.$root.$on("loadToMap", self.loadToMap);
    self.$root.$on("flashFeatures", self.flashFeatures);
    self.$root.$on("findFeatureById", (id, layerName, type) => {
      let feature = this.findFeatureById(+id, `${layerName}`, type);
      if(feature) {
        this.zoomToFeature(feature);
      } else {
        this.$root.$emit(
          "showSnackbar",
          "red",
          "Nie znaleziono takiej warstwy lub klucza"
        );
      }
    });
    self.$root.$on("addWMSLayer", self.addWMSLayer);
    self.$root.$on("deleteLayer", self.deleteLayer);

    self.map.on("dblclick", evt => {
      if(self.isClickable) {
        document.getElementById("map").style.cursor = "default";
        self.pointCoords = evt.coordinate;
        self.show("addScadaPointModal");
      }
      self.isClickable = false;

      let feature = self.map.forEachFeatureAtPixel(evt.pixel, feature => {
        return feature;
      });
      if(feature) {
        if(feature.values_.type == "videos") {
          this.$store.commit("setCurrentVideo", feature.values_.properties);
          this.$root.$emit('loadVideoInspection', feature.values_)
          this.show("videoInspectionCardModal");
        } else if(feature.values_.type == "refurbishments") {
          this.$store.commit(
            "setCurrentRefurbishment",
            feature.values_.properties
          );
          this.show("addRefurbishmentModal");
        } else if(feature.values_.type == "variances") {
          this.$store.commit("setCurrentVariance", feature.values_.properties);
          this.show("varianceCardModal");
        }
      }
    });

    self.$root.$on("chackLastChangeSource", self.chackLastChangeSource);
    self.$root.$on("chackStatusSubService", self.chackStatusSubService);
    self.chackLastChangeSource();
    self.chackStatusSubService();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/map/Map.vue